<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
    <!-- <form @submit.prevent="salvar">
      <q-card> -->
    <q-card-main>
      <!-- <q-tab-pane name="identificacaoProcesso"> -->
      <div class="row">
        <div class="col-10 gvn-title-primary mrg-t-0">
          Identificação do Processo
        </div>
        <div class="col-sm-1 text-right">
          <q-tooltip v-if="imprimir == true">Histórico de Movimentação</q-tooltip>
          <q-btn
            id="visualizarHistorico"
            name="visualizarHistorico"
            v-if="imprimir == true"
            icon="fas fa-history"
            color="primary"
            @click="visualizarHistorico"
            flat
          >&ensp;&ensp;Histórico
          </q-btn>
        </div>
        <div class="col-sm-1 text-right">
          <q-tooltip v-if="imprimir == true">Comprovante de encaminhamento</q-tooltip>
          <q-btn
            id="imprimirComprovanteEncaminhamento"
            name="imprimirComprovanteEncaminhamento"
            v-if="imprimir == true"
            icon="fa fa-print"
            color="primary"
            @click="imprimirComprovanteEncaminhamento"
            flat
          >&ensp;&ensp;Imprimir
          </q-btn>
        </div>
      </div>
      <div class="row">
        <div
          class="col-sm-2 col-xs-4"
          style="padding-top: 9px"
        >
          <g-input
            id="refCodigo"
            name="refCodigo"
            ref="refCodigo"
            tipo="text"
            etiqueta="Código"
            validacao="numeric"
            :foco="false"
            :desabilitar="true"
            v-model="paginaStatus.aberturaProcesso.codProcesso"
          ></g-input>
        </div>
        <div
          class="col-sm-2 col-xs-4"
          style="padding-top: 9px"
        >
          <g-input
            id="refNumProcesso"
            name="refNumProcesso"
            ref="refNumProcesso"
            mascara="numero"
            validacao="Number"
            :tamanho="10"
            etiqueta="Nº Processo"
            :foco="false"
            :desabilitar="paginaStatus.desabilitarEdicao"
            v-model="paginaStatus.aberturaProcesso.numProcesso"
          ></g-input>
        </div>
        <div
          class="col-sm-2 col-xs-4"
          style="padding-top: 9px"
        >
          <g-input
            id="refAnoProcesso"
            name="refAnoProcesso"
            ref="refAnoProcesso"
            mascara="numero"
            validacao="required | Number"
            :tamanho="4"
            etiqueta="Ano Processo"
            :foco="false"
            :desabilitar="paginaStatus.desabilitarEdicao"
            v-model="paginaStatus.aberturaProcesso.anoProcesso"
          ></g-input>
        </div>
        <div
          class="col-sm-3 col-xs-6"
          style="padding: 9px 30px 0 0;"
        >
          <!-- <g-datepicker
            ref="refDataProcesso"
            etiqueta="Data Processo"
            :desabilitar="paginaStatus.desabilitarEdicao"
            v-model="paginaStatus.aberturaProcesso.datProcesso"
          >
          </g-datepicker> -->
          <!-- Date & Time -->
          <!-- <q-datetime
            id="dataHoraProcesso"
            name="dataHoraProcesso"
            v-model="dataHoraProcesso"
            type="datetime"
            float-label="Data e Hora"
            :disable="desabilitarDataHoraProcesso"
            :max="new Date()"
            format24h
            format="DD-MM-YYYY HH:mm:ss"
          /> -->
          <g-dateInput
            id="dataHoraProcesso"
            name="dataHoraProcesso"
            ref="refDataHoraProcesso"
            etiqueta="Data Abertura"
            v-model="dataHoraProcesso"
            :desabilitar="paginaStatus.desabilitarEdicao"
            :somenteLeitura="paginaStatus.desabilitarEdicao"
            validacao="required"
            :dataMax="new Date()"
          >
          </g-dateInput>
        </div>
        <div
          class="col-sm-3 col-xs-6"
          style="padding-top: 9px"
        >
          <g-input
            mascara="hora"
            ref="refHorProcesso"
            validacao="hora"
            :tamanho="5"
            etiqueta="Hora Processo"
            :foco="false"
            :desabilitar="paginaStatus.desabilitarEdicao"
            v-model="horaProcesso"
          >
          </g-input>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2 col-xs-4">
          <g-input
            id="refNumProtocolo"
            name="refNumProtocolo"
            mascara="numero"
            ref="refNumProtocolo"
            etiqueta="Nº Protocolo"
            :foco="false"
            :desabilitar="true"
            v-model="paginaStatus.aberturaProcesso.numProtocolo"
          ></g-input>
        </div>
        <div class="col-sm-2 col-xs-4">
          <g-input
            id="refNumProcessoExterno"
            name="refNumProcessoExterno"
            mascara="numero"
            ref="refNumProcessoExterno"
            validacao="Number"
            :tamanho="10"
            etiqueta="Nº Processo Externo"
            :foco="false"
            :desabilitar="desabilitarNumProcessoExterno"
            v-model="paginaStatus.aberturaProcesso.numProcessoExterno"
          ></g-input>
        </div>
        <div class="col-sm-2 col-xs-4">
          <g-input
            id="refNumProcessoAnterior"
            name="refNumProcessoAnterior"
            mascara="numero"
            ref="refNumProcessoAnterior"
            validacao="Number"
            :tamanho="10"
            etiqueta="Nº Processo Anterior"
            :foco="false"
            :desabilitar="desabilitarNumProcessoAnterior"
            v-model="paginaStatus.aberturaProcesso.numProcessoAnterior"
          ></g-input>
        </div>
        <div class="col-sm-3 col-xs-6">
          <g-input
            id="refAnoProcessoAnterior"
            name="refAnoProcessoAnterior"
            ref="refAnoProcessoAnterior"
            mascara="numero"
            validacao="Number"
            :tamanho="4"
            etiqueta="Ano Processo Anterior"
            :foco="false"
            :desabilitar="desabilitarAnoProcessoAnterior"
            v-model="paginaStatus.aberturaProcesso.anoProcessoAnterior"
          ></g-input>
        </div>
        <div class="col-sm-3 col-xs-6">
          <g-input
            id="refCodigoBarra"
            name="refCodigoBarra"
            ref="refCodigoBarra"
            tipo="text"
            etiqueta="Código de Barras"
            validacao="maxlength(50)"
            :tamanho="50"
            :foco="false"
            :desabilitar="true"
            v-model="codBarra"
          ></g-input>
        </div>
        <div
          class="col-2 col-sm-2 col-xs-4"
          style="padding-top: 10px"
        >
          <q-toggle
            id="clonarProcesso"
            name="clonarProcesso"
            v-if="exibirClone"
            v-model="clonarProcesso"
            label="Clonar Processo"
            color="teal-8"
            :disable="paginaStatus.desabilitarEdicao"
            true-value="S"
            false-value="N"
            checked-icon="check"
            unchecked-icon="clear"
          />
        </div>
        <div
          class="col-2 col-sm-2 col-xs-4"
          style="margin-top: -20px"
        >
          <g-input
            id="refQdeProcesso"
            name="refQdeProcesso"
            v-if="exibirClone"
            mascara="numero"
            ref="refQdeProcesso"
            validacao="Number"
            etiqueta="Quantidade"
            :tamanho="4"
            :foco="false"
            :desabilitar="clonarProcesso == 'N'"
            v-model="qdeProcesso"
          ></g-input>
        </div>
      </div>
    </q-card-main>
    <!--</q-card> -->
    <q-card>
      <q-card-main>
        <q-tabs
          inverted
          v-model="abaSelecionada"
        >
          <q-tab
            slot="title"
            label="Dados do processo"
            name="dadosProcesso"
          />
          <q-tab
            slot="title"
            label="Dados do requerente"
            name="dadosRequerente"
          />
          <q-tab
            slot="title"
            label="Dados complementares"
            name="dadosComplemetares"
          />
          <q-tab
            slot="title"
            label="Documentos"
            name="documentos"
          />
          <q-tab
            slot="title"
            label="Dados Impressão do Comprovante"
            name="comprovante"
          />
          <q-tab-pane name="dadosProcesso">
            <div class="row">
              <div class="col-sm-6 col-xs-6">
                <g-autocomplete
                  id="refFormaSolicitacao"
                  name="refFormaSolicitacao"
                  ref="refFormaSolicitacao"
                  etiqueta="Forma de Solicitação"
                  valor="codFormaSolicitacao"
                  validacao="required | text"
                  :foco="false"
                  descricaoPrimaria="desFormaSolicitacao"
                  :api="apiformaSolicitacao"
                  :desabilitar="desabilitarFormaSolicitacao"
                  v-model="paginaStatus.aberturaProcesso.formaSolicitacao.codFormaSolicitacao"
                ></g-autocomplete>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4 col-xs-4">
                <g-input
                  id="refVlrProcesso"
                  name="refVlrProcesso"
                  ref="refVlrProcesso"
                  validacao="Number"
                  mascara="numeroDuasCasasDecimais"
                  :tamanho="14"
                  etiqueta="Valor do Processo"
                  :foco="false"
                  :desabilitar="desabilitarVlrProcesso"
                  v-model="paginaStatus.aberturaProcesso.vlrProcesso"
                ></g-input>
              </div>
              <div class="col-sm-4 col-xs-4">
                <g-input
                  id="refTxtProcesso"
                  name="refTxtProcesso"
                  ref="refTxtProcesso"
                  validacao="Number"
                  :tamanho="40"
                  etiqueta="Nota Fiscal"
                  :foco="false"
                  :desabilitar="desabilitarNotaFiscal"
                  v-model="paginaStatus.aberturaProcesso.txtNotaFiscal"
                ></g-input>
              </div>
              <div class="col-sm-3 col-xs-3">
                <g-input
                  id="refInscricaoImovel"
                  name="refInscricaoImovel"
                  ref="refInscricaoImovel"
                  :tamanho="15"
                  etiqueta="Inscrição Imóvel"
                  :foco="false"
                  :desabilitar="false"
                  v-model="paginaStatus.aberturaProcesso.numInscricao"
                ></g-input>
              </div>
              <div
                v-if="permissaoAcessoImovel"
                class="col-sm-1 col-xs-1"
                style="padding: 15px 30px 0 0;"
              >
                <q-btn
                  icon="fa fa-search"
                  style="background: #550059 !important; color: white"
                  @click="pesquisarImovel"
                >
                </q-btn>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 col-xs-6">
                <g-input
                  id="refEnderecoImovel"
                  name="refEnderecoImovel"
                  ref="refEnderecoImovel"
                  :tamanho="150"
                  etiqueta="Endereço Imóvel"
                  :foco="false"
                  :desabilitar="false"
                  v-model="desEndereco"
                ></g-input>
              </div>
              <div class="col-sm-3 col-xs-3">
                <g-input
                  id="refTipoImovel"
                  name="refTipoImovel"
                  ref="refTipoImovel"
                  :tamanho="50"
                  etiqueta="Tipo de Imposto"
                  :foco="false"
                  :desabilitar="false"
                  v-model="tipoImovel"
                ></g-input>
              </div>
              <div class="col-sm-3 col-xs-3">
                <g-input
                  id="refAreaLote"
                  name="refAreaLote"
                  ref="refAreaLote"
                  :tamanho="22"
                  etiqueta="Área do Lote"
                  validacao="Number"
                  mascara="numeroDuasCasasDecimais"
                  :foco="false"
                  :desabilitar="false"
                  v-model="areaLote"
                ></g-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 col-xs-6">
                <g-autocomplete
                  id="refTipoProcesso"
                  name="refTipoProcesso"
                  ref="refTipoProcesso"
                  etiqueta="Tipo de Processo"
                  valor="codTipoProcesso"
                  validacao="required | text"
                  :foco="false"
                  descricaoPrimaria="desTipoProcesso"
                  :api="apitipoProcesso"
                  :desabilitar="desabilitarTipoProcesso"
                  :acaoPosSelecao="buscarDadosTipoProcesso"
                  :onchange="mudanca()"
                  v-model="codTipoProcesso"
                ></g-autocomplete>
              </div>
              <div class="col-sm-6 col-xs-6">
                <g-autocomplete
                  id="refAssunto"
                  name="refAssunto"
                  ref="refAssunto"
                  etiqueta="Assunto"
                  valor="codAssunto"
                  :foco="false"
                  validacao="required"
                  descricaoPrimaria="desAssunto"
                  :api="apiAssunto"
                  :filtroAdicional="getFiltroAssunto"
                  :onchange="mudanca()"
                  :desabilitar="desabilitarAssunto"
                  v-model="codAssunto"
                ></g-autocomplete>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 col-xs-6">
                <g-autocomplete
                  id="refSubAssunto"
                  name="refSubAssunto"
                  ref="refSubAssunto"
                  etiqueta="Subassunto"
                  :foco="false"
                  valor="codSubassunto"
                  validacao="required"
                  descricaoPrimaria="desSubassunto"
                  :desabilitar="desabilitarSubAssunto"
                  :api="apiSubAssunto"
                  :filtroAdicional="getFiltroSubAssunto"
                  :acaoPosSelecao="buscarDocumentoNecessario"
                  :onchange="mudanca()"
                  v-model="codSubassunto"
                ></g-autocomplete>
              </div>
              <div class="col-sm-6 col-xs-6">
                <g-select
                  id="refNumRota"
                  name="refNumRota"
                  ref="refNumRota"
                  etiqueta="Nº da Rota"
                  :foco="false"
                  :itens="rotaArray"
                  item-valor="numRota"
                  item-etiqueta="numRota"
                  :desabilitar="desabilitarRota"
                  :adicionarLinhaEmBranco="false"
                  :change="buscarDadosRoteiro"
                  v-model="paginaStatus.aberturaProcesso.roteiro.numRota"
                ></g-select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-xs-12">
                <g-autocomplete
                  id="refJustificativa"
                  name="refJustificativa"
                  ref="refJustificativa"
                  etiqueta="Justificativa"
                  valor="codJustificativa"
                  :foco="false"
                  validacao="required"
                  descricaoPrimaria="desJustificativa"
                  :desabilitar="desabilitarJustificativa"
                  :api="apiJustificativa"
                  :filtroAdicional="getFiltroJustificativa"
                  v-model="paginaStatus.aberturaProcesso.justificativa.codJustificativa"
                ></g-autocomplete>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-xs-12">
                <g-timeLine
                  id="refTimeLine"
                  name="refTimeLine"
                  ref="refTimeLine"
                  :itens="dadosRoteiroArray"
                  titulo="Etapas da sequência"
                  conteudo="{n}{d}Previsão de dias:{/d} {p}numPrevisaoDias{/p} | {p}setor.unidade.orgao.desOrgao{/p} | {p}setor.unidade.desUnidade{/p} | {n}{p}setor.desSetor{/p}"
                ></g-timeLine>
              </div>
            </div>
          </q-tab-pane>
          <q-tab-pane name="dadosRequerente">
            <div class="row">
              <div class="col-sm-12 col-xs-12">
                <g-autocomplete
                  id="refRequerente"
                  name="refRequerente"
                  ref="refRequerente"
                  etiqueta="Requerente"
                  valor="codRequerente"
                  :foco="false"
                  validacao="required"
                  descricaoPrimaria="nomeDataNascimentoDocumento"
                  :acaoPosSelecao="buscarDadosRequerente"
                  :desabilitar="paginaStatus.desabilitarEdicao"
                  :api="apiRequerente"
                  :limparAdicional="limparDadosRequerente"
                  v-model="paginaStatus.aberturaProcesso.requerente.codRequerente"
                ></g-autocomplete>
              </div>
              <div
                class="col-sm-1 col-xs-1"
                v-if="operacao === 'Novo'"
              >
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4 col-xs-4">
                <g-input
                  id="refTelefoneMovel"
                  name="refTelefoneMovel"
                  mascara="telefone"
                  ref="refTelefoneMovel"
                  validacao="Text"
                  etiqueta="Telefone Celular"
                  :foco="false"
                  :desabilitar="desabilitarTelefoneRequerente"
                  v-model="paginaStatus.aberturaProcesso.requerente.numTelefoneMovel"
                ></g-input>
              </div>
              <div class="col-sm-4 col-xs-4">
                <g-input
                  id="refTelefoneResidencial"
                  name="refTelefoneResidencial"
                  mascara="telefone"
                  ref="refTelefoneResidencial"
                  validacao="Text"
                  etiqueta="Telefone Residencial"
                  :foco="false"
                  :desabilitar="desabilitarTelefoneRequerente"
                  v-model="paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial"
                ></g-input>
              </div>
              <div class="col-sm-4 col-xs-4">
                <g-input
                  id="refTelefoneComercial"
                  name="refTelefoneComercial"
                  mascara="telefone"
                  ref="refTelefoneComercial"
                  validacao="Text"
                  etiqueta="Telefone Comercial"
                  :foco="false"
                  :desabilitar="desabilitarTelefoneRequerente"
                  v-model="paginaStatus.aberturaProcesso.requerente.numTelefoneComercial"
                ></g-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-xs-12">
                <g-autocomplete
                  id="refRepresentante"
                  name="refRepresentante"
                  ref="refRepresentante"
                  etiqueta="Representante"
                  valor="codRepresentante"
                  :foco="false"
                  validacao="text"
                  descricaoPrimaria="nomeDataNascimentoDocumento"
                  :acaoPosSelecao="buscarDadosRepresentante"
                  :desabilitar="paginaStatus.desabilitarEdicao"
                  :api="apiRequerente"
                  :limparAdicional="limparDadosRepresentante"
                  v-model="paginaStatus.aberturaProcesso.representante.codRepresentante"
                ></g-autocomplete>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4 col-xs-4">
                <g-input
                  id="refTelefoneMovelRepresentante"
                  name="refTelefoneMovelRepresentante"
                  mascara="telefone"
                  ref="refTelefoneMovelRepresentante"
                  validacao="Text"
                  etiqueta="Telefone Celular"
                  :foco="false"
                  :desabilitar="desabilitarTelefoneRepresentante"
                  v-model="paginaStatus.aberturaProcesso.representante.numTelefoneMovel"
                ></g-input>
              </div>
              <div class="col-sm-4 col-xs-4">
                <g-input
                  id="refTelefoneResidencialRepresentante"
                  name="refTelefoneResidencialRepresentante"
                  mascara="telefone"
                  ref="refTelefoneResidencialRepresentante"
                  validacao="Text"
                  etiqueta="Telefone Residencial"
                  :foco="false"
                  :desabilitar="desabilitarTelefoneRepresentante"
                  v-model="paginaStatus.aberturaProcesso.representante.numTelefoneResidencial"
                ></g-input>
              </div>
              <div class="col-sm-4 col-xs-4">
                <g-input
                  id="refTelefoneComercialRepresentante"
                  name="refTelefoneComercialRepresentante"
                  mascara="telefone"
                  ref="refTelefoneComercialRepresentante"
                  validacao="Text"
                  etiqueta="Telefone Comercial"
                  :foco="false"
                  :desabilitar="desabilitarTelefoneRepresentante"
                  v-model="paginaStatus.aberturaProcesso.representante.numTelefoneComercial"
                ></g-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-xs-12">
                <g-input
                  id="refEmail"
                  name="refEmail"
                  ref="refEmail"
                  validacao="email | maxlength(100)"
                  :tamanho="100"
                  etiqueta="E-mail"
                  :foco="false"
                  :desabilitar="paginaStatus.desabilitarEdicao"
                  v-model="paginaStatus.aberturaProcesso.txtEmail"
                ></g-input>
              </div>
            </div>
          </q-tab-pane>
          <q-tab-pane name="dadosComplemetares">
            <div class="row">
              <div
                class="col-sm-6 col-xs-6"
                style="padding-top: 9px"
              >
                <g-input
                  id="refCapa"
                  name="refCapa"
                  ref="refCapa"
                  validacao="required | Text"
                  etiqueta="Capa Processo (Cor)"
                  :foco="false"
                  :desabilitar="true"
                  v-model="paginaStatus.aberturaProcesso.tipoProcesso.txtCapaCor"
                ></g-input>
              </div>
              <div
                class="col-sm-3 col-xs-3"
                style="padding-top: 9px"
              >
                <g-input
                  id="refTramitacao"
                  name="refTramitacao"
                  ref="refTramitacao"
                  validacao="required | Text"
                  etiqueta="Tempo Tramitação (Dias úteis)"
                  :foco="false"
                  :desabilitar="true"
                  v-model="numPrevisao"
                ></g-input>
              </div>
              <div
                class="col-sm-3 col-xs-3"
                style="padding: 9px 30px 0 0;"
              >
                <g-input
                  id="refDataEstimativaConclusao"
                  name="refDataEstimativaConclusao"
                  ref="refDataEstimativaConclusao"
                  etiqueta="Data Estimativa Conclusão"
                  :foco="false"
                  :desabilitar="true"
                  v-model="dataEstimativaConclusao"
                >
                </g-input>
              </div>
              <!-- <div
                class="col-sm-3 col-xs-3"
                style="padding-right: 30px;"
              >
                <g-datepicker
                  id="refDataEstimativaConclusao"
                  name="refDataEstimativaConclusao"
                  ref="refDataEstimativaConclusao"
                  etiqueta="Data Estimativa Conclusão"
                  :desabilitar="true"
                  v-model="dataEstimativaConclusao"
                ></g-datepicker>
              </div> -->
            </div>
            <div class="row">
              <div class="col-sm-12 col-xs-12">
                <g-input
                  id="refObservacao"
                  name="refObservacao"
                  ref="refObservacao"
                  etiqueta="Observação"
                  validacao="Text | maxlength(5000)"
                  tipo="textarea"
                  :tamanho=5000
                  :foco="false"
                  :desabilitar="desabilitarObs"
                  v-model="paginaStatus.aberturaProcesso.txtObservacao"
                ></g-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 col-xs-6">
                <g-input
                  id="reforgaoOrigem"
                  name="reforgaoOrigem"
                  ref="reforgaoOrigem"
                  tipo="text"
                  etiqueta="Órgão Origem"
                  validacao="required"
                  :foco="false"
                  :desabilitar="true"
                  v-model="paginaStatus.aberturaProcesso.roteiro.setor.unidade.orgao.desOrgao"
                ></g-input>
              </div>
              <div class="col-sm-6 col-xs-6">
                <g-input
                  id="refunidadeOrigem"
                  name="refunidadeOrigem"
                  ref="refunidadeOrigem"
                  tipo="text"
                  etiqueta="Unidade Origem"
                  validacao="required"
                  :foco="false"
                  :desabilitar="true"
                  v-model="paginaStatus.aberturaProcesso.roteiro.setor.unidade.desUnidade"
                ></g-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 col-xs-6">
                <g-input
                  id="refSetorOrigem"
                  name="refSetorOrigem"
                  ref="refSetorOrigem"
                  tipo="text"
                  etiqueta="Setor Origem"
                  validacao="required"
                  :foco="false"
                  :desabilitar="true"
                  v-model="paginaStatus.aberturaProcesso.roteiro.setor.desSetor"
                ></g-input>
              </div>
              <div class="col-sm-6 col-xs-6">
                <g-autocomplete
                  id="refResponsavel"
                  name="refResponsavel"
                  ref="refResponsavel"
                  etiqueta="Responsável"
                  valor="codResponsavel"
                  :foco="false"
                  validacao="required"
                  descricaoPrimaria="usuario.nomUsuario"
                  :desabilitar="true"
                  :api="apiResponsavelSetor"
                  :filtroAdicional="getFiltroResponsavel"
                  v-model="paginaStatus.aberturaProcesso.responsavel.codResponsavel"
                ></g-autocomplete>
              </div>
            </div>
          </q-tab-pane>
          <q-tab-pane name="documentos">
            <div
              class="row mrg-b-20"
              v-show="dadosDocumentoNecessarioArray.length > 0"
            >
              <table
                class="col-md-12"
                cellspacing="0"
                cellpadding="0"
              >
                <thead>
                  <tr>
                    <th
                      class="text-left"
                      width="50%"
                    >Documentação Necessária Entregue</th>
                  </tr>
                </thead>
                <!--{{documentoToggle}}-->
                <tbody>
                  <tr
                    v-for="doc in dadosDocumentoNecessarioArray"
                    v-bind:key="doc.a"
                  >
                    <td class="text-left">
                      <q-toggle
                        id="desabilitarDocumentos"
                        name="desabilitarDocumentos"
                        :disable="desabilitarDocumentos"
                        v-model="documentoToggle"
                        color="teal-8"
                        :val="doc"
                        true-value="S"
                        false-value="N"
                        checked-icon="check"
                        unchecked-icon="clear"
                      />
                      &ensp;&ensp;
                      {{doc.documento.nomDocumento}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <g-gridview
              v-show="this.clonarProcesso === 'N'"
              id="refGridDocumentos"
              name="refGridDocumentos"
              ref="refGridDocumentos"
              :exibirEtiqueta="false"
              :colunas="colunasGrid"
              :inserirElemento="setElemento"
              :getElemento="getElemento"
              :editarElemento="editarElemento"
              :executarValidacao="validarDocumento"
              :limparCampos="limparDocumento"
              :exibirBotaoExclusaoFuncao="exibirBotaoExclusao"
              :confExcluir="confExcluirDocumento"
              :inicializarVazio="true"
              :exibirBotaoVisualizacao="false"
              :exibirBotaoEdicao="false"
              :operacoes="operacoes"
            >
              <div class="row">
                <span class="titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <i class="titulo-icone fas fa-file"></i> Arquivos anexados na solicitação
                </span>
              </div>
              <div class="row">
                <div
                  class="col-sm-6 col-xs-6"
                  style="padding-top: 9px; "
                >
                  <q-uploader
                    color="secondary"
                    ref="refUploader"
                    name="arquivo"
                    type="file"
                    auto-expand
                    hide-upload-button
                    hide-upload-progress
                    validacao="required"
                    stack-label="Selecionar arquivo (Tamanho máximo: 200Mb)"
                    :url="urlArquivo"
                    :filter="filtroDeArquivos"
                  />
                </div>
                <div
                  class="col-sm-6 col-xs-6"
                  style="padding-top: 9px; "
                >
                  <g-input
                    id="refDocumento"
                    name="refDocumento"
                    ref="refDocumento"
                    tipo="text"
                    etiqueta="Documento"
                    :tamanho=100
                    :foco="false"
                    v-model="nomDocumento"
                  >
                  </g-input>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-sm-12 col-xs-12"
                  style="padding-top: 9px"
                >
                  <g-input
                    id="refObservacao"
                    name="refObservacao"
                    ref="refObservacao"
                    tipo="textarea"
                    etiqueta="Observação"
                    :tamanho=1000
                    :foco="false"
                    v-model="txtObservacao"
                  >
                  </g-input>
                </div>
              </div>
            </g-gridview>
          </q-tab-pane>
          <q-tab-pane name="comprovante">
            <div class="row">
              <div
                class="col-sm-3 col-xs-3"
                style="padding-top: 30px"
              >
                <q-toggle
                  id="indLiberadoProtocolo"
                  name="indLiberadoProtocolo"
                  v-model="indLiberadoProtocolo"
                  label="Liberado pelo Protocolo"
                  color="teal-8"
                  :disable="desabilitarComprovante"
                  true-value="S"
                  false-value="N"
                  checked-icon="check"
                  unchecked-icon="clear"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 col-xs-6">
                <g-input
                  id="refContato"
                  name="refContato"
                  ref="refContato"
                  validacao="Text | maxlength(100)"
                  :tamanho="100"
                  tipo="text"
                  etiqueta="Contato"
                  :foco="false"
                  :desabilitar="desabilitarComprovante"
                  v-model="paginaStatus.aberturaProcesso.txtContato"
                ></g-input>
              </div>
              <div class="col-sm-6 col-xs-6">
                <g-input
                  id="refIdentificacao"
                  name="refIdentificacao"
                  ref="refIdentificacao"
                  validacao="Text | maxlength(100)"
                  :tamanho="100"
                  tipo="text"
                  etiqueta="Identificação"
                  :foco="false"
                  :desabilitar="desabilitarComprovante"
                  v-model="paginaStatus.aberturaProcesso.txtIdentificacao"
                ></g-input>
              </div>
            </div>
            <br><br>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                Endereço:&ensp;&ensp;Requerente/Contribuinte&ensp;
                <q-toggle
                  id="indTipoEndereco"
                  name="indTipoEndereco"
                  v-model="indTipoEndereco"
                  label="Imóvel do Contribuinte"
                  color="teal-8"
                  :disable="desabilitarComprovante"
                  true-value="I"
                  false-value="R"
                  checked-icon="check"
                  unchecked-icon="clear"
                />
              </div>
            </div>
          </q-tab-pane>
        </q-tabs>
      </q-card-main>
    </q-card>
    <!-- </form> -->
    <div class="col-12 text-right pad-20t-h10-80b">
      <q-btn
        round
        id="salvar"
        name="salvar"
        class="fixed"
        color="positive"
        icon="check"
        size="lg"
        @click="salvar"
        style="right: 18px; bottom:18px"
        v-show="visualizarSalvar"
      >
        <q-tooltip>Salvar</q-tooltip>
      </q-btn>
    </div>
  </div>
</template>
<script>
import api from 'components/util/api'
import util from 'components/util/util'
import msg from 'components/util/msg'
import utilHttp from 'components/util/utilHttp'
import GInput from 'components/util/gInput'
import GSelect from 'components/util/gSelect'
import GAutocomplete from 'components/util/gAutocomplete'
import GDatepicker from 'components/util/gDatepicker'
import GBreadcrumb from 'components/util/gBreadcrumb'
import GTimeLine from 'components/util/gTimeLine'
import GDateInput from 'components/util/gDateInput'
import GGridview from 'components/util/gGridview'
import GDatatable from 'components/util/gDatatable'

export default {

  data () {
    return {
      // api usadas
      apiDocumento: api.DOCUMENTO,
      apiDocumentoAnexoProcesso: api.DOCUMENTO_ANEXO_PROCESSO,
      apiaberturaProcesso: api.ABERTURA_PROCESSO,
      apiformaSolicitacao: api.FORMA_SOLICITACAO,
      apitipoProcesso: api.TIPO_DE_PROCESSO_ROTEIRO,
      apiAssunto: api.ASSUNTO_ROTEIRO,
      apiSubAssunto: api.SUB_ASSUNTO_ROTEIRO,
      apiRequerente: api.REQUERENTE,
      apiJustificativa: api.JUSTIFICATIVA_SUBASSUNTO,
      apiOrgao: api.ORGAO,
      apiUnidade: api.BUSCAR_UNIDADE_ORGAO,
      apiSetor: api.SETOR_UNIDADE,
      apiResponsavelSetor: api.RESPONSAVEL_SETOR,
      apiImprimirRelatorio: api.RELATORIO_COMPROVANTE_ENCAMINHAMENTO,
      apiDownloadArquivos: api.DOCUMENTO_ANEXO_PROCESSO_DOWNLOAD_ARQUIVOS,
      apiDadosImovel: api.ABERTURA_PROCESSO_DADOS_IMOVEL,
      // variáveis
      disponibilidade: 'INT',
      imprimir: false,
      newPaginaStatus: '',
      dataHoraProcesso: '',
      horaProcesso: '',
      codBarra: '',
      documentoUpload: '',
      codUsuario: '',
      codDocumento: '',
      txtObservacao: '',
      nomDocumento: '',
      datProcesso: '',
      dataAnexo: '',
      urlArquivo: '',
      arquivo: '',
      clonarProcesso: 'N',
      exibirClone: '',
      qdeProcesso: '',
      numProcessoIncial: '',
      numProcessoFinal: '',
      operacao: '',
      txtEmailRequerente: '',
      txtEmailRepresentante: '',
      numPrevisao: '',
      codTipoProcesso: '',
      permissaoAcessoImovel: false,
      desabilitarSubAssunto: true,
      desabilitarRota: true,
      desabilitarTipoProcesso: false,
      desabilitarAssunto: true,
      desabilitarObs: false,
      desabilitarFormaSolicitacao: false,
      desabilitarTelefoneRequerente: false,
      desabilitarTelefoneRepresentante: false,
      desabilitarNumProcessoExterno: false,
      desabilitarNumProcessoAnterior: false,
      desabilitarAnoProcessoAnterior: false,
      desabilitarDataHoraProcesso: false,
      desabilitarDocumentos: false,
      desabilitarComprovante: false,
      desabilitarVlrProcesso: false,
      desabilitarNotaFiscal: false,
      visualizarSalvar: true,
      exibirArquivosSolicitacao: false,
      // modalRequerente: false,
      indLiberadoProtocolo: '',
      alterouSubAssunto: false,
      indTipoEndereco: '',
      codAssunto: '',
      assuntoInicio: false,
      codSubassunto: '',
      subassuntoInicio: false,
      rotaArray: [],
      dadosRoteiroArray: [],
      dadosDocumentoNecessarioArray: [],
      aberturaProcessoDocumento: [],
      arrayDocumentoAnexoProcessoBkp: [],
      numRota: '',
      desabilitarJustificativa: '',
      desOrgao: '',
      dataEstimativaConclusao: '',
      chaveLocalStorage: 'aberturaProcesso',
      abaSelecionada: '',
      emiteComprovante: '',
      nomeComprovanteAbertura: '',
      desabilitarResponsavel: true,
      exibirQtdeClone: false,
      documentoToggle: [],
      aberturaProcessoVisaoArray: [],
      roteiroLista: {},
      parametrosSistema: {},
      desEndereco: '',
      areaLote: '',
      tipoImovel: '',
      documentoSelecionado: {
        documento: {
          arquivo: {}
        }
      },
      nomeDataNascimentoDocumento: '',
      paginaStatus: {
        operacao: {},
        nomeDataNascimentoDocumento: '',
        aberturaProcesso: {
          formaSolicitacao: {},
          tipoProcesso: {},
          subassunto: {
            assunto: {}
          },
          roteiro: {
            setor: {
              unidade: {
                orgao: {}
              }
            }
          },
          requerente: {},
          representante: {},
          justificativa: {},
          responsavel: { usuario: {} },
          documentoNecessario: {},
          aberturaProcessoDocumento: {}
        },
        documentoProcesso: {},
        movimentacaoProcesso: {},
        documentoAnexoProcessoSalvarList: [],
        documentoAnexoProcessoExcluirList: []
      },
      confExcluirDocumento: {
        clique: (item) => this.confExcluirDocumentoFuncao(item)
      },
      operacoes: [
        {
          cor: 'black',
          icone: 'fas fa-download',
          tooltip: 'Baixar Arquivo',
          clique: this.baixarAnexo,
          permissao: (row) => true,
          visivel: (row) => this.validarArquivoAntesDeBaixar(row)
        }
      ],
      colunasGrid: [
        {
          conteudoTipo: '',
          largura: '30%',
          cabecalhoEtiqueta: 'Documento',
          cabecalhoClasse: 'text-left',
          conteudoClasse: 'text-left',
          propriedade: 'documento.nomDocumento',
          chave: 'documento.nomDocumento'
        },
        {
          conteudoTipo: '',
          largura: '30%',
          cabecalhoEtiqueta: 'Observação',
          cabecalhoClasse: 'text-left',
          conteudoClasse: 'text-left',
          propriedade: 'txtObservacao'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoEtiqueta: 'Tamanho aproximado do arquivo',
          cabecalhoClasse: 'text-left',
          conteudoClasse: 'text-left',
          propriedade: 'tamanhoArquivo',
          formatar: (valor) => this.formatarTamanhoArquivo(valor)
        }
      ],
      arrayDisponibilidadeArray: [
        { codigo: 'INT', descricao: 'Internamente' },
        { codigo: 'EXT', descricao: 'Externamente' },
        { codigo: 'ENC', descricao: 'Externamente (Apenas no encerramento do processo)' }
      ]
    }
  },
  methods: {
    // GRID Arquivos anexados na solicitação //////////////////////////////////////
    validarDocumento () {
      var self = this
      if (self.nomDocumento === '') {
        util.exibirToastAviso(msg.m(11, 'Documento'))
        return false
      } else if (self.$refs['refUploader'].files[0] === undefined) {
        util.exibirToastAviso(msg.m(11, 'Arquivo'))
        return false
      } else {
        let lista = self.$refs['refGridDocumentos'].getDados()
        if (lista.length > 0) {
          let initialValue = 0
          lista.forEach(item => {
            let tamanhoAtualizado = 0
            if (!util.validarCampo(item.tamanhoArquivo)) {
              tamanhoAtualizado = parseFloat(item.documento.arquivo.size) / 1024 / 1024
            } else {
              tamanhoAtualizado = parseFloat(item.tamanhoArquivo) / 1024 / 1024
            }
            initialValue = initialValue + parseFloat(tamanhoAtualizado)
          })
          if ((parseFloat(initialValue.toFixed(4)) + parseFloat((self.documentoSelecionado.documento.arquivo.size / 1024 / 1024).toFixed(4))) > 200.000) {
            util.exibirToastAviso('Não foi possível incluir o arquivo [' + self.documentoSelecionado.documento.arquivo.name + '], o limite total de 200Mb foi ultrapassado!')
            return false
          }
        }
        if (self.nomDocumento &&
          self.disponibilidade &&
          self.nomDocumento &&
          self.$refs['refUploader'].files[0]) {
          return true
        } else {
          return false
        }
      }
    },
    setElemento () {
      var self = this
      self.documentoSelecionado = util.clonarObjeto(self.documentoSelecionado)
      if (self.$refs['refUploader'] !== undefined && self.$refs['refUploader'] !== '' && self.$refs['refUploader'] !== null) {
        self.documentoSelecionado.documento.arquivo = self.$refs['refUploader'].files[0]
      }
      self.paginaStatus.documentoAnexoProcessoSalvarList.push(self.documentoSelecionado)
      return self.documentoSelecionado
    },
    getElemento () {
      var self = this
      if (self.nomDocumento !== '' && self.$refs['refUploader'].files[0]) {
        self.documentoSelecionado = JSON.parse(JSON.stringify(self.documentoSelecionado))
        self.documentoSelecionado.documento = {}
        self.documentoSelecionado.documento.nomDocumento = self.nomDocumento
        if (self.$refs['refUploader'] !== undefined && self.$refs['refUploader'] !== '' && self.$refs['refUploader'] !== null) {
          self.documentoSelecionado.documento.arquivo = self.$refs['refUploader'].files[0]
        }
        self.documentoSelecionado.txtObservacao = util.validarCampo(self.txtObservacao) ? self.txtObservacao : ''
        self.documentoSelecionado.codUsuario = self.$login.getCodUsuario()
        self.documentoSelecionado.indDisponibilidade = self.disponibilidade
        self.documentoSelecionado.tamanhoArquivo = parseFloat(self.documentoSelecionado.documento.arquivo.size)
        // Verificar se o elemento selecionado existe na lista de exclusão, se existir, o retira
        var doc = self.paginaStatus.documentoAnexoProcessoExcluirList.filter(d => d.documento.nomDocumento === self.documentoSelecionado.documento.nomDocumento)
        if (doc !== undefined && doc != null && doc.length > 0) {
          self.paginaStatus.documentoAnexoProcessoExcluirList.splice(doc, 1)
        }
        return util.clonarObjeto(self.documentoSelecionado)
      } else {
        return self.documentoSelecionado
      }
    },
    editarElemento (item) {
      var self = this
      // correcao do icone de editar sumir quando carrega outro grid
      if (this.paginaStatus.operacao.descricao === 'Visualizar') {
        self.$refs['refGridDocumentos'].indexEdicao = ''
      }
      self.documentoSelecionado = item
      self.nomDocumento = self.documentoSelecionado.documento.nomDocumento
      self.txtObservacao = self.documentoSelecionado.txtObservacao
      self.indDisponibilidade = item.indDisponibilidade
    },
    confExcluirDocumentoFuncao (item) {
      var self = this
      util.exibirConfirmacaoExclusao('EXCLUSÃO', msg.m(5), () => {
        let array = util.clonarObjeto(self.paginaStatus.documentoAnexoProcessoSalvarList)
        for (let index = 0; index < array.length; index++) {
          const x = self.paginaStatus.documentoAnexoProcessoSalvarList[index]
          if (x.documento.nomDocumento === item.documento.nomDocumento) {
            self.paginaStatus.documentoAnexoProcessoSalvarList.splice(index, 1) // remove 1 elemento do índice buscado
            self.$refs['refGridDocumentos'].removerElementoAposConfirmacaoExclusao(item)
            self.paginaStatus.documentoAnexoProcessoExcluirList.push(item)
            break
          }
        }
      })
    },
    limparDocumento () {
      var self = this
      self.$refs['refUploader'].reset()
      self.nomDocumento = ''
      self.txtObservacao = ''
      self.documentoSelecionado = util.clonarObjeto({ documento: { nomDocumento: '' } })
    },
    pesquisarImovel () {
      var self = this
      var url = self.apiDadosImovel.concat('?numInscricao=').concat(self.paginaStatus.aberturaProcesso.numInscricao)
      utilHttp.httpGet(url, resposta => {
        if (resposta.body !== undefined && resposta.body !== '') {
          if (resposta.body.desEndereco || resposta.body.areaLote || resposta.body.tipoImovel) {
            self.desEndereco = resposta.body.desEndereco
            self.areaLote = resposta.body.areaLote
            self.tipoImovel = resposta.body.tipoImovel
          } else {
            self.desEndereco = ''
            self.areaLote = ''
            self.tipoImovel = ''
            util.exibirToastAviso('A inscrição informada não possui dados do imóvel cadastrados.')
          }
        } else {
          self.desEndereco = ''
          self.areaLote = ''
          self.tipoImovel = ''
          util.exibirToastAviso('A inscrição informada não possui dados do imóvel cadastrados.')
        }
      })
    },
    filtroDeArquivos (files) {
      const MAX_FILE_SIZE = 200 * 1024 * 1024 /* =25M */
      // returns an Array containing allowed files
      return files.filter((file) => {
        if (file.size > MAX_FILE_SIZE) {
          util.exibirToastAviso('Arquivo [' + files[0].name + '] excede o tamanho permitido: 200 Mb')
        }
        return file.size <= MAX_FILE_SIZE
      })
    },
    formatarTamanhoArquivo (tamanho) {
      return (tamanho / 1024 / 1024).toFixed(4) + ' Mb'
    },
    carregarArquivosAnexadosNaSolicitacao () {
      if (this.paginaStatus.documentoAnexoProcessoSalvarList.length > 0) {
        setTimeout(() => {
          if (this.$refs['refGridDocumentos']) {
            this.$refs['refGridDocumentos'].inicializar(util.clonarObjeto(this.paginaStatus.documentoAnexoProcessoSalvarList))
          }
        }, 100)
      }
    },
    validarArquivoAntesDeBaixar (item) {
      if (util.validarCampo(item.codUpload)) {
        return true
      } else {
        if (util.validarCampo(item.servidorArquivo)) {
          if (util.validarCampo(item.servidorArquivo.codArquivo)) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    exibirBotaoExclusao (linha) {
      if (this.paginaStatus.operacao.descricao === 'Visualizar') {
        return false
      } else if (util.validarObjeto(linha.codUpload)) {
        return false
      } else {
        return true
      }
    },
    // GRID Arquivos anexados na solicitação //////////////////////////////////////
    baixarAnexo (item) {
      var self = this
      let url = self.apiDownloadArquivos.concat('/')
      if (util.validarCampo(item.codUpload)) {
        url += item.codUpload
      } else {
        if (util.validarCampo(item.servidorArquivo)) {
          if (util.validarCampo(item.servidorArquivo.codArquivo)) {
            url += item.servidorArquivo.codArquivo
          } else {
            util.exibirToastAviso('Arquivo não encontrado')
            return
          }
        } else {
          util.exibirToastAviso('Arquivo não encontrado')
          return
        }
      }
      utilHttp.httpGet(url, resposta => {
        location.href = url
      })
    },
    setDataHoraAtual () {
      var self = this
      let dataAtual = new Date()

      self.dataHoraProcesso = util.formatarData(dataAtual, 'dd/mm/yyyy')
      self.horaProcesso = dataAtual.getHours().toString().concat(':')
      self.horaProcesso = self.horaProcesso.toString().concat(dataAtual.getMinutes().toString().length === 1 ? '0'.concat(dataAtual.getMinutes()) : dataAtual.getMinutes())
    },
    filtroAdicionalResponsavel () {
      var filtro = ''
        .concat('/').concat(this.paginaStatus.documentoAnexoProcesso.aberturaProcesso.roteiro.setor.codSetor)
        .concat('/').concat(this.paginaStatus.documentoAnexoProcesso.aberturaProcesso.roteiro.setor.unidade.codUnidade)
        .concat('/').concat(this.paginaStatus.documentoAnexoProcesso.aberturaProcesso.roteiro.setor.unidade.orgao.codOrgao)
      return filtro
    },
    mudanca () {
      var self = this
      // Tratamento para quando os campos TipoProcesso, CodAssunto e CodSubassunto são apagados
      if (!self.codTipoProcesso || !self.codAssunto || !self.codSubassunto) {
        self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.orgao.desOrgao = ''
        self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.desUnidade = ''
        self.paginaStatus.aberturaProcesso.roteiro.setor.desSetor = ''
        self.numPrevisao = ''
        self.dataEstimativaConclusao = ''
        if (!self.paginaStatus.operacao) {
          self.paginaStatus.operacao = {}
        }
        if (self.paginaStatus.operacao.descricao === 'Novo') {
          self.paginaStatus.aberturaProcesso.responsavel.usuario.nomUsuario = ''
        }
      } else if (self.codTipoProcesso && self.codAssunto && self.codSubassunto && self.paginaStatus.operacao.descricao === 'Novo') {
        self.desabilitarRota = false
      }
    },
    imprimirComprovanteEncaminhamento () {
      var self = this
      let url = ''
      url = self.apiImprimirRelatorio.concat('?codProcesso=').concat(self.paginaStatus.aberturaProcesso.codProcesso.toString())
      url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      url = url.concat('&nomComprovanteEncaminhamento=').concat(self.parametrosSistema.nomComprovanteEncaminhamento)
      window.open(url)
    },
    salvar () {
      var self = this
      self.paginaStatus.aberturaProcesso.indStatusProcesso = 'ABE'
      self.paginaStatus.aberturaProcesso.datProcesso = new Date(util.formatarAnoMesDia(self.dataHoraProcesso, 'DD/MM/YYYY'))
      self.paginaStatus.aberturaProcesso.horProcesso = self.horaProcesso.concat(':00')
      if (self.paginaStatus.aberturaProcesso.representante.codRequerente === '' || self.paginaStatus.aberturaProcesso.representante.codRequerente === undefined) {
        self.paginaStatus.aberturaProcesso.representante = {}
      }

      // Obs: A verificação padrão "util.validarComponentes($refs)" estava ocorrendo apenas com
      // os elementos da aba selecionada ao clicar no botão Salvar, sendo necessário criar uma validação
      // para testar todos os elementos requeridos.

      if (util.validarComponentes(this.$refs)) {
        if (self.validarComponentes()) {
          // self.removerMascaras()
          self.visualizarSalvar = false
          util.mostrarCarregando()
          var aberturaProcessoVisao = {
            aberturaProcesso: {},
            aberturaProcessoDocumentosList: [],
            movimentacaoProcesso: {},
            documentoAnexoProcessoExcluirList: []
          }
          self.paginaStatus.aberturaProcesso.codUsuario = self.$login.getCodUsuario()
          if (self.paginaStatus.aberturaProcesso.indLiberadoProtocolo === undefined) {
            self.paginaStatus.aberturaProcesso.indLiberadoProtocolo = 'N'
          }
          if (self.paginaStatus.aberturaProcesso.indTipoEndereco === undefined) {
            self.paginaStatus.aberturaProcesso.indTipoEndereco = 'R'
          }
          self.paginaStatus.aberturaProcesso.roteiro.numPrevisaoDias = self.numPrevisao
          var movimentacaoProcesso = {
            numSequencia: 1,
            txtObservacaoMovimento: 'Abertura do Processo',
            indStatusProcesso: 'ABE',
            numSequenciaRota: self.paginaStatus.aberturaProcesso.roteiro.numSequencia,
            setor: self.paginaStatus.aberturaProcesso.roteiro.setor,
            setorConfirmacao: self.paginaStatus.aberturaProcesso.roteiro.setor,
            numSequenciaRotaAlternativa: 0,
            txtObeservacaoConfirmacao: '',
            codUsuario: self.$login.getCodUsuario()
          }
          self.documentoToggle.forEach(doc => {
            var aberturaProcessoDocumento = {
              codUsuario: self.$login.getCodUsuario(),
              documentacaoNecessaria: doc
            }
            aberturaProcessoVisao.aberturaProcessoDocumentosList.push(aberturaProcessoDocumento)
          })
          aberturaProcessoVisao.aberturaProcesso = self.paginaStatus.aberturaProcesso
          aberturaProcessoVisao.movimentacaoProcesso = movimentacaoProcesso

          // Exclusão dos Documentos Anexos excluidos
          let array = util.clonarObjeto(self.paginaStatus.documentoAnexoProcessoExcluirList)
          for (let index = 0; index < array.length; index++) {
            const x = self.paginaStatus.documentoAnexoProcessoExcluirList[index]

            if (x.codAnexo !== undefined) {
              aberturaProcessoVisao.documentoAnexoProcessoExcluirList.push(x)
            }
          }

          if (self.paginaStatus.aberturaProcesso.codProcesso !== undefined && self.paginaStatus.aberturaProcesso.codProcesso !== null) {
            self.removerMascaras()

            var filtro = '/'.concat(self.paginaStatus.aberturaProcesso.codProcesso)
            utilHttp.httpPut(api.ABERTURA_PROCESSO.concat(filtro), aberturaProcessoVisao, resposta => {
              if (resposta.status === 200) {
                self.abaSelecionada = 'documentos'
                setTimeout(() => {
                  util.mostrarCarregando()
                }, 100)
                setTimeout(() => {
                  util.mostrarCarregando()

                  let lista = self.$refs['refGridDocumentos'].getDados().filter(x => (x.id === undefined || x.id === null || x.id === '') && (x.codAnexo === undefined || x.codAnexo === null || x.codAnexo === ''))
                  if (lista.length > 0) {
                    // Necessário salvar item por item da lista por conta do arquivo de upload
                    // util.mostrarCarregando()

                    lista.forEach(d => {
                      const formData = new FormData()
                      formData.append('arquivo', d.documento.arquivo)
                      formData.append('codResponsavel', resposta.body.responsavel.codResponsavel)
                      formData.append('codDocumento', util.validarCampo(d.documento.codDocumento) ? d.documento.codDocumento : 0)
                      formData.append('indDisponibilidade', d.indDisponibilidade)
                      formData.append('observacao', d.txtObservacao)
                      formData.append('codProcesso', resposta.body.codProcesso)
                      formData.append('codUsuario', d.codUsuario)
                      formData.append('datAnexacao', resposta.body.datProcesso.replace('T', ' '))
                      formData.append('indAnexadoAbertura', 'S')
                      formData.append('nomDocumento', d.documento.nomDocumento)
                      utilHttp.httpPostMultpartRequest(self.apiDocumentoAnexoProcesso, formData, resposta2 => {
                      })
                    })
                  }
                  setTimeout(() => {
                    util.esconderCarregando()
                    util.exibirToastSucesso(msg.m(3))
                    util.retornarCaminhoMigalhaPaginaAnterior(self)
                  }, 3000)
                }, 1000)
              } else {
                self.visualizarSalvar = true
                util.esconderCarregando()
                util.exibirToastFalha('Favor verificar os campos informados')
              }
            }
            )
          } else {
            self.aberturaProcessoVisaoArray = []
            // self.setArrayAberturaProcessoVisao(aberturaProcessoVisao)
            if (self.qdeProcesso !== null && self.qdeProcesso !== undefined && self.qdeProcesso !== '') {
              util.exibirConfirmacao('Clonar processo', 'Pretende realmente criar '.concat(self.qdeProcesso.toString()).concat(' registros de processos?'), 'Sim', 'Não', () => {
                self.removerMascaras()
                for (let i = 0; i < parseInt(self.paginaStatus.aberturaProcesso.qdeProcesso) + 1; i++) {
                  self.aberturaProcessoVisaoArray.push(aberturaProcessoVisao)
                }
                self.salvarAbertura()
              }
              )
            } else {
              self.removerMascaras()
              self.aberturaProcessoVisaoArray.push(aberturaProcessoVisao)
              self.salvarAbertura()
            }
          }
        }
      }
    },
    validarComponentes () {
      var self = this
      var listaCamposVazios = []
      if (
        self.verificarCampoNulo(self.paginaStatus.aberturaProcesso.anoProcesso)
      ) {
        listaCamposVazios.push('Ano Processo')
      }
      if (
        self.verificarCampoNulo(self.paginaStatus.aberturaProcesso.datProcesso)
      ) {
        listaCamposVazios.push('Data e Hora do Processo')
      }
      if (
        self.verificarCampoNulo(
          self.paginaStatus.aberturaProcesso.formaSolicitacao
            .codFormaSolicitacao
        )
      ) {
        listaCamposVazios.push('Forma de Solicitação')
      }
      if (
        self.verificarCampoNulo(self.codTipoProcesso)
      ) {
        listaCamposVazios.push('Tipo de Processo')
      }
      if (self.verificarCampoNulo(self.codAssunto)) {
        listaCamposVazios.push('Assunto')
      }
      if (self.verificarCampoNulo(self.codSubassunto)) {
        listaCamposVazios.push('Sub Assunto')
      }
      if (
        self.verificarCampoNulo(
          self.paginaStatus.aberturaProcesso.requerente.codRequerente
        )
      ) {
        listaCamposVazios.push('Requerente')
      }
      if (
        self.verificarCampoNulo(
          self.paginaStatus.aberturaProcesso.tipoProcesso.txtCapaCor
        )
      ) {
        listaCamposVazios.push('Cor da capa')
      }
      if (
        self.verificarCampoNulo(
          // self.paginaStatus.aberturaProcesso.roteiro.numPrevisaoDias
          self.numPrevisao
        )
      ) {
        listaCamposVazios.push('Previsão de dias')
      }
      if (
        self.verificarCampoNulo(
          self.paginaStatus.aberturaProcesso.justificativa.codJustificativa
        )
      ) {
        listaCamposVazios.push('Justificativa')
      }
      if (
        self.verificarCampoNulo(
          self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.orgao
            .desOrgao
        )
      ) {
        listaCamposVazios.push('Órgão')
      }
      if (
        self.verificarCampoNulo(
          self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.desUnidade
        )
      ) {
        listaCamposVazios.push('Unidade')
      }
      if (
        self.verificarCampoNulo(
          self.paginaStatus.aberturaProcesso.roteiro.setor.desSetor
        )
      ) {
        listaCamposVazios.push('Setor')
      }

      // if (
      //   self.verificarCampoNulo(
      //     self.paginaStatus.aberturaProcesso.responsavel.codResponsavel
      //   )
      // ) {
      //   listaCamposVazios.push('Responsável')
      // }

      if (listaCamposVazios.length === 1) {
        // Apenas um componente inválido
        util.exibirToastAviso(
          'Favor preencher campo vazio: '.concat(listaCamposVazios[0])
        )
        return false
      } else if (listaCamposVazios.length > 1) {
        // Múltiplos componentes inválidos
        var campos = ''
        var count = 0
        listaCamposVazios.forEach(c => {
          count = count + 1
          if (count === listaCamposVazios.length) {
            campos = campos.concat(c).concat('. ')
          } else {
            campos = campos.concat(c).concat(', ')
          }
        })
        util.exibirToastAviso(
          'Favor preencher os campos vazios: '.concat(campos)
        )
        return false
      }

      if (self.paginaStatus.aberturaProcesso.anoProcesso < new Date().getFullYear() - 1) {
        util.exibirToastAviso('Ano Processo não pode ser menor que '.concat(new Date().getFullYear() - 1))
        return false
      }
      if (self.paginaStatus.aberturaProcesso.anoProcesso > new Date().getFullYear()) {
        util.exibirToastAviso('Ano Processo não pode ser maior que '.concat(new Date().getFullYear()))
        return false
      }
      if (self.verificarCampoNulo(self.paginaStatus.aberturaProcesso.anoProcessoAnterior) === false && self.paginaStatus.aberturaProcesso.anoProcessoAnterior < 1900) {
        util.exibirToastAviso('Ano Processo Anterior inválido.')
        return false
      }

      if (self.verificarCampoNulo(self.paginaStatus.aberturaProcesso.responsavel.codResponsavel)) {
        util.exibirToastAviso('Usuário não é Responsável pela Rota.')
        return false
      }

      if (self.parametrosSistema.indTelefoneRequerente === 'S' && self.verificarCampoNulo(self.paginaStatus.aberturaProcesso.requerente.numTelefoneMovel) && self.verificarCampoNulo(self.paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial) && self.verificarCampoNulo(self.paginaStatus.aberturaProcesso.requerente.numTelefoneComercial)) {
        util.exibirToastAviso('O requerente deve possuir ao menos um telefone cadastrado.')
        return false
      }

      return true
    },
    verificarCampoNulo (campo) {
      if ((campo !== undefined && campo !== '' && campo != null) || campo === 0) {
        return false
      } else {
        return true
      }
    },
    salvarAbertura () {
      var self = this
      var filtroProcesso = ''
      utilHttp.httpPost(api.ABERTURA_PROCESSO, self.aberturaProcessoVisaoArray, resposta => {
        if (resposta.status === 201) {
          util.mostrarCarregando()
          if (self.clonarProcesso === 'N') {
            let lista = self.paginaStatus.documentoAnexoProcessoSalvarList
            if (lista.length > 0) {
              util.mostrarCarregando()
              // Necessário salvar item por item da lista por conta do arquivo de upload
              lista.forEach(d => {
                const formData = new FormData()
                formData.append('arquivo', d.documento.arquivo)
                formData.append('codResponsavel', resposta.body[0].responsavel.codResponsavel)
                formData.append('codDocumento', util.validarCampo(d.documento.codDocumento) ? d.documento.codDocumento : 0)
                formData.append('indDisponibilidade', d.indDisponibilidade)
                formData.append('observacao', d.txtObservacao)
                formData.append('codProcesso', resposta.body[0].codProcesso)
                formData.append('codUsuario', d.codUsuario)
                formData.append('datAnexacao', resposta.body[0].datProcesso.replace('T', ' '))
                formData.append('indAnexadoAbertura', 'S')
                formData.append('nomDocumento', d.documento.nomDocumento)
                utilHttp.httpPostMultpartRequest(self.apiDocumentoAnexoProcesso, formData, resposta => {
                })
              })
            }
          }
          // imprimir comprovante
          if (self.emiteComprovante === 'S') {
            resposta.body.forEach(processo => {
              filtroProcesso = filtroProcesso.concat(processo.codProcesso).concat(',')
            })
            filtroProcesso = filtroProcesso.substring(0, filtroProcesso.length - 1)
            let url = ''
            url = this.apiImprimirRelatorio.concat('?codProcesso=').concat(filtroProcesso)
            url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
            url = url.concat('&nomComprovanteEncaminhamento=').concat(self.parametrosSistema.nomComprovanteEncaminhamento)
            utilHttp.httpGet(url, resposta => {
              window.open(url)
            })
          } else {
            if (self.emiteComprovante === 'P') {
              util.exibirConfirmacao('Emitir Comprovante', 'Deseja emitir comprovante?', 'Sim', 'Não', () => {
                resposta.body.forEach(processo => {
                  filtroProcesso = filtroProcesso.concat(processo.codProcesso).concat(',')
                })
                filtroProcesso = filtroProcesso.substring(0, filtroProcesso.length - 1)
                let url = ''
                url = this.apiImprimirRelatorio.concat('?codProcesso=').concat(filtroProcesso)
                url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
                url = url.concat('&nomComprovanteEncaminhamento=').concat(self.parametrosSistema.nomComprovanteEncaminhamento)
                utilHttp.httpGet(url, resposta => {
                  window.open(url)
                })
              })
            }
          }
          setTimeout(() => {
            util.esconderCarregando()
            util.exibirToastSucesso(msg.m(2))
            util.retornarCaminhoMigalhaPaginaAnterior(this)
          }, 3000)
        } else {
          self.visualizarSalvar = true
          util.esconderCarregando()
          util.exibirToastFalha('Favor verificar os campos informados')
        }
      }
      )
    },
    setArrayAberturaProcessoVisao (aberturaProcessoVisao) {
      var self = this
      if (
        self.qdeProcesso !== null &&
        self.qdeProcesso !== undefined &&
        self.qdeProcesso !== ''
      ) {
        util.exibirConfirmacao(
          'Clonar processo',
          'Pretende realmente criar '
            .concat(self.qdeProcesso.toString())
            .concat(' registros de processos?'),
          'Sim',
          'Não',
          () => {
            for (
              let i = 0;
              i < this.paginaStatus.aberturaProcesso.qdeProcesso;
              i++
            ) {
              self.aberturaProcessoVisaoArray.push(aberturaProcessoVisao)
            }
          }
        )
      } else {
        self.aberturaProcessoVisaoArray.push(aberturaProcessoVisao)
      }
    },
    removerMascaras () {
      // Por padrão, os dados são salvos no banco sem formatação
      // if (this.paginaStatus.aberturaProcesso.horProcesso !== null &&
      //   this.paginaStatus.aberturaProcesso.horProcesso !== '' &&
      //   this.paginaStatus.aberturaProcesso.horProcesso !== undefined
      // ) {
      //   this.paginaStatus.aberturaProcesso.horProcesso = util.removerFormatacao(
      //     this.paginaStatus.aberturaProcesso.horProcesso.toString()
      //   )
      // }
      if (this.paginaStatus.aberturaProcesso.requerente !== null &&
        this.paginaStatus.aberturaProcesso.requerente !== undefined &&
        this.paginaStatus.aberturaProcesso.requerente !== ''
      ) {
        if (this.paginaStatus.aberturaProcesso.requerente.numTelefoneMovel !== null &&
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneMovel !== '' &&
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneMovel !== undefined
        ) {
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneMovel = util.removerFormatacao(
            this.paginaStatus.aberturaProcesso.requerente.numTelefoneMovel.toString()
          )
        }
        if (this.paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial !== null &&
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial !== '' &&
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial !== undefined
        ) {
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial = util.removerFormatacao(
            this.paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial.toString()
          )
        }
        if (this.paginaStatus.aberturaProcesso.requerente.numTelefoneComercial !== null &&
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneComercial !== '' &&
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneComercial !== undefined
        ) {
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneComercial = util.removerFormatacao(
            this.paginaStatus.aberturaProcesso.requerente.numTelefoneComercial.toString()
          )
        }
      }

      if (this.paginaStatus.aberturaProcesso.representante !== null &&
        this.paginaStatus.aberturaProcesso.representante !== undefined &&
        this.paginaStatus.aberturaProcesso.representante !== '') {
        if (this.paginaStatus.aberturaProcesso.representante.numTelefoneMovel !== null &&
          this.paginaStatus.aberturaProcesso.representante.numTelefoneMovel !== '' &&
          this.paginaStatus.aberturaProcesso.representante.numTelefoneMovel !== undefined
        ) {
          this.paginaStatus.aberturaProcesso.representante.numTelefoneMovel = util.removerFormatacao(
            this.paginaStatus.aberturaProcesso.representante.numTelefoneMovel.toString()
          )
        }
        if (this.paginaStatus.aberturaProcesso.representante.numTelefoneResidencial !== null &&
          this.paginaStatus.aberturaProcesso.representante.numTelefoneResidencial !== '' &&
          this.paginaStatus.aberturaProcesso.representante.numTelefoneResidencial !== undefined
        ) {
          this.paginaStatus.aberturaProcesso.representante.numTelefoneResidencial = util.removerFormatacao(
            this.paginaStatus.aberturaProcesso.representante.numTelefoneResidencial.toString()
          )
        }
        if (this.paginaStatus.aberturaProcesso.representante.numTelefoneComercial !== null &&
          this.paginaStatus.aberturaProcesso.representante.numTelefoneComercial !== '' &&
          this.paginaStatus.aberturaProcesso.representante.numTelefoneComercial !== undefined
        ) {
          this.paginaStatus.aberturaProcesso.representante.numTelefoneComercial = util.removerFormatacao(
            this.paginaStatus.aberturaProcesso.representante.numTelefoneComercial.toString()
          )
        }
      }

      if (this.paginaStatus.aberturaProcesso.vlrProcesso !== null &&
        this.paginaStatus.aberturaProcesso.vlrProcesso !== '' &&
        this.paginaStatus.aberturaProcesso.vlrProcesso !== undefined
      ) {
        this.paginaStatus.aberturaProcesso.vlrProcesso = util.trocarVirgulaPorPonto(
          this.paginaStatus.aberturaProcesso.vlrProcesso.toString()
        )
      }
    },
    getFiltroAssunto () {
      var filtro = ''
      filtro = filtro.concat('/').concat(this.codTipoProcesso)
      return filtro
    },
    getFiltroSubAssunto () {
      var filtro = ''
      filtro = filtro.concat('/').concat(this.codAssunto)
      return filtro
    },
    getFiltroRoteiroProcesso () {
      var filtro = ''
      filtro = filtro
        .concat('/')
        .concat(this.codTipoProcesso)
        .concat('/')
        .concat(this.codAssunto)
        .concat('/')
        .concat(this.codSubassunto)
      return filtro
    },
    getFiltroJustificativa () {
      var filtro = ''
      filtro = filtro
        .concat('/')
        .concat(this.codTipoProcesso)
        .concat('/')
        .concat(this.codAssunto)
        .concat('/')
        .concat(this.codSubassunto)
        .concat('/S') // indDisponivelConsulta
      return filtro
    },
    getFiltroResponsavel () {
      var filtro = ''
        .concat('/')
        .concat(this.paginaStatus.aberturaProcesso.roteiro.setor.codSetor)
        .concat('/')
        .concat(
          this.paginaStatus.aberturaProcesso.roteiro.setor.unidade.codUnidade
        )
        .concat('/')
        .concat(
          this.paginaStatus.aberturaProcesso.roteiro.setor.unidade.orgao
            .codOrgao
        )
      return filtro
    },
    buscarRotaPeloProcessoSubassunto () {
      var self = this
      var usuarioAbertura = ''
      if (self.paginaStatus.operacao.descricao === 'Visualizar') {
        usuarioAbertura = self.paginaStatus.aberturaProcesso.codUsuario
      } else { usuarioAbertura = self.$login.getCodUsuario() }
      var filtro = ''
        .concat('?codTipoProcesso=')
        .concat(self.codTipoProcesso)
        .concat('&codAssunto=')
        .concat(self.codAssunto)
        .concat('&codSubassunto=')
        .concat(self.codSubassunto)
        .concat('&codUsuario=')
        // .concat(self.$login.getCodUsuario())
        .concat(usuarioAbertura)
      utilHttp.httpGet(api.ROTEIRO_ASSUNTO_USUARIO.concat(filtro), resposta => {
        self.rotaArray = resposta.body

        if (self.paginaStatus.operacao.descricao === 'Novo') {
          if (self.rotaArray.length > 0) {
            self.paginaStatus.aberturaProcesso.roteiro.numRota = self.rotaArray[0].numRota
            self.buscarDadosRoteiro()
          } else {
            util.exibirToastAviso('Usuário logado não é responsável para o setor de abertura desse processo!')
          }
        }
      })
    },
    buscarResponsavel () {
      var self = this
      var responsavelSetor = {}
      var filtro = ''
        .concat('?codUsuario=')
        .concat(self.$login.getCodUsuario())
        .concat('&codSetor=')
        .concat(self.paginaStatus.aberturaProcesso.roteiro.setor.codSetor)
        .concat('&codUnidade=')
        .concat(self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.codUnidade)
        .concat('&codOrgao=')
        .concat(self.paginaStatus.aberturaProcesso.roteiro.setor.unidade.orgao.codOrgao)
        .concat('&indModulo=')
        .concat('PRO')

      utilHttp.httpGet(api.RESPONSAVEL_SETOR_USUARIO_SETOR_UNIDADE_ORGAO.concat(filtro), resposta => {
        responsavelSetor = resposta.body

        if (responsavelSetor) {
          self.paginaStatus.aberturaProcesso.responsavel = responsavelSetor
        }
      })
    },
    buscarDadosRoteiro () {
      var self = this
      if (self.paginaStatus.aberturaProcesso.tipoProcesso.codTipoProcesso) {
        self.codTipoProcesso = self.paginaStatus.aberturaProcesso.tipoProcesso.codTipoProcesso
      }
      if (self.paginaStatus.aberturaProcesso.subassunto.assunto.codAssunto) {
        self.codAssunto = self.paginaStatus.aberturaProcesso.subassunto.assunto.codAssunto
      }
      if (self.paginaStatus.aberturaProcesso.subassunto.codSubassunto) {
        self.codSubassunto = self.paginaStatus.aberturaProcesso.subassunto.codSubassunto
      }
      var filtro = ''
        .concat('?numRota=')
        .concat(self.paginaStatus.aberturaProcesso.roteiro.numRota)
        .concat('&codTipoProcesso=')
        .concat(self.codTipoProcesso)
        .concat('&codAssunto=')
        .concat(self.codAssunto)
        .concat('&codSubassunto=')
        .concat(self.codSubassunto)

      utilHttp.httpGet(api.ROTEIRO_SEQUENCIA.concat(filtro), resposta => {
        self.$refs['refTimeLine'].limpar()
        self.dadosRoteiroArray = resposta.body
        if (self.dadosRoteiroArray.length >= 0) {
          self.paginaStatus.aberturaProcesso.roteiro =
            self.dadosRoteiroArray[0]
          if (this.paginaStatus.operacao.descricao === 'Novo') {
            self.buscarResponsavel()
          }
          self.desabilitarResponsavel = false
        }

        self.somaTempoTramitacao()

        // self.paginaStatus.aberturaProcesso.roteiro.numPrevisaoDias = self.somaPrevisao()
        // var dataProcesso = new Date(self.paginaStatus.aberturaProcesso.datProcesso)
        // var novaData = new Date()
        // novaData.setDate(dataProcesso.getDate() + self.paginaStatus.aberturaProcesso.roteiro.numPrevisaoDias)
        // self.dataEstimativaConclusao = util.criarData(novaData)
      })
    },
    visualizarHistorico (objeto) {
      var self = this
      objeto = this.paginaStatus.aberturaProcesso
      self.paginaStatus.aberturaProcesso = objeto
      if (!self.paginaStatus.aberturaProcesso.representante) {
        self.paginaStatus.aberturaProcesso.representante = ''
      }
      self.paginaStatus.desabilitarEdicao = true
      self.paginaStatus.operacao = {
        descricao: 'Histórico',
        icone: 'fas fa-history'
      }
      self.$router.push({
        name: 'aberturaProcessoVisualizar',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    buscarDocumentoNecessario (objeto) {
      var self = this

      if (self.paginaStatus.aberturaProcesso.tipoProcesso.codTipoProcesso) {
        self.codTipoProcesso = self.paginaStatus.aberturaProcesso.tipoProcesso.codTipoProcesso
      }
      if (self.paginaStatus.aberturaProcesso.subassunto.assunto.codAssunto) {
        self.codAssunto = self.paginaStatus.aberturaProcesso.subassunto.assunto.codAssunto
      }

      if (!objeto && self.paginaStatus.operacao.descricao === 'Novo') {
        if (self.paginaStatus.aberturaProcesso.subassunto.codSubassunto) {
          self.codSubassunto = self.paginaStatus.aberturaProcesso.subassunto.codSubassunto
        }
      } else {
        if (self.paginaStatus.aberturaProcesso.subassunto.codSubassunto) {
          objeto.valorObjeto.codSubassunto =
            self.paginaStatus.aberturaProcesso.subassunto.codSubassunto
        }
      }

      var filtro = ''
        .concat('?codTipoProcesso=')
        .concat(self.codTipoProcesso)
        .concat('&codAssunto=')
        .concat(self.codAssunto)
        .concat('&codSubassunto=')
      if (!objeto && self.paginaStatus.operacao.descricao === 'Novo') {
        filtro = filtro.concat(self.codSubassunto)
      } else {
        filtro = filtro.concat(objeto.valorObjeto.codSubassunto)
      }
      utilHttp.httpGet(
        api.DOCUMENTACAO_NECESSARIA_TIPO_PROCESSO_E_ASSUNTO_SUBASSUNTO.concat(
          filtro
        ),
        resposta => {
          self.dadosDocumentoNecessarioArray = resposta.body
        }
      )
    },
    buscarDocumentacaoApresentada () {
      var self = this
      var filtro = ''
        .concat('?codTipoProcesso=')
        .concat(self.paginaStatus.aberturaProcesso.tipoProcesso.codTipoProcesso)
        .concat('&codAssunto=')
        .concat(
          self.paginaStatus.aberturaProcesso.subassunto.assunto.codAssunto
        )
        .concat('&codSubassunto=')
        .concat(self.paginaStatus.aberturaProcesso.subassunto.codSubassunto)

      utilHttp.httpGet(
        api.DOCUMENTACAO_NECESSARIA_TIPO_PROCESSO_E_ASSUNTO_SUBASSUNTO.concat(
          filtro
        ),
        docs => {
          utilHttp.httpGet(
            api.BUSCAR_ABERTURA_PROCESSO_DOCUMENTO.concat('/').concat(
              self.paginaStatus.aberturaProcesso.codProcesso
            ),
            aberturaProcessoDocs => {
              // self.dadosDocumentoNecessarioArray = docs.body
              self.aberturaProcessoDocs = aberturaProcessoDocs.body

              docs.body.forEach(docs => {
                var item = self.aberturaProcessoDocs.filter(
                  p =>
                    p.documentacaoNecessaria.documento.codDocumento ===
                    docs.documento.codDocumento
                )
                if (item.length > 0) {
                  docs.documento.indSelecionado = 'S'
                  self.documentoToggle.push(docs)
                } else {
                  docs.documento.indSelecionado = 'N'
                  // self.documentoToggle.push(docs)
                }
              })
              self.dadosDocumentoNecessarioArray = docs.body
            }
          )

          // if (this.lengthdadosDocumentoNecessarioArray.length > 0) {
          //   apidocumentoprocessoaArray api.ABERTURA_PROCESSO_DOCUMENTO
          //   dadosDocumentoNecessarioArray.forEach(doc => {
          //     apidocumentoprocessoaArray.forEach(docSelecionado => {
          //       if(doc.codDocumento === docSelecionado.codDocumento){
          //         this.documentoToggle = 'S'
          //       }
          //     })
          //   })
          // }
        }
      )
    },
    buscarDadosRepresentante (objeto) {
      this.paginaStatus.aberturaProcesso.representante = this.$refs['refRepresentante'].objetoSelecionado
      this.paginaStatus.aberturaProcesso.requerente.txtEmail = this.paginaStatus.aberturaProcesso.representante.txtEmail
      this.txtEmailRepresentante = this.paginaStatus.aberturaProcesso.representante.txtEmail
      this.paginaStatus.aberturaProcesso.txtEmail = this.paginaStatus.aberturaProcesso.representante.txtEmail
    },
    buscarDadosRequerente (objeto) {
      this.paginaStatus.aberturaProcesso.requerente = this.$refs['refRequerente'].objetoSelecionado
      this.paginaStatus.aberturaProcesso.requerente.txtEmail = this.paginaStatus.aberturaProcesso.requerente.txtEmail
      this.txtEmailRequerente = this.paginaStatus.aberturaProcesso.requerente.txtEmail
      // Se não tem nenhum representante
      if (!this.paginaStatus.aberturaProcesso.representante.termo) {
        this.paginaStatus.aberturaProcesso.txtEmail = this.paginaStatus.aberturaProcesso.requerente.txtEmail
        this.txtEmailRequerente = this.paginaStatus.aberturaProcesso.requerente.txtEmail
      }
    },
    buscarDadosTipoProcesso (objeto) {
      this.paginaStatus.aberturaProcesso.tipoProcesso.txtCapaCor = this.$refs['refTipoProcesso'].objetoSelecionado.txtCapaCor
    },
    buscarParametrosSistema () {
      var self = this
      utilHttp.httpGet(api.PARAMETROS_SISTEMA, resposta => {
        if (resposta.body !== undefined && resposta.body !== '') {
          self.parametrosSistema = resposta.body

          self.emiteComprovante = self.parametrosSistema.indImpressaoAbertura
          if (self.parametrosSistema.desAcessoImovel) {
            self.permissaoAcessoImovel = true
          }
          self.nomeComprovanteAbertura = self.parametrosSistema.nomeComprovanteMovimento
        } else {
          util.exibirToastAviso('Os parâmetros para envio de e-mail do sistema não foram salvos. Caminho: MENU > CONFIGURAÇÃO > PARÂMETRO')
          self.emiteComprovante = 'S'
          self.nomeComprovanteAbertura = 'RelatorioComprovanteEncaminhamento'
        }
      })
    },
    somaTempoTramitacao () {
      var self = this

      // Quantidade de dias corridos
      var listaRoteiro = this.dadosRoteiroArray
      var somaPrevisaoDias = 0

      listaRoteiro.forEach(lista => {
        if (
          lista.numPrevisaoDias !== '' &&
          lista.numPrevisaoDias !== undefined &&
          lista.numPrevisaoDias !== null
        ) {
          somaPrevisaoDias = somaPrevisaoDias + lista.numPrevisaoDias
        }
      })
      self.setDataEstimada(self.dataHoraProcesso, somaPrevisaoDias)
      // self.paginaStatus.aberturaProcesso.roteiro.numPrevisaoDias = somaPrevisaoDias
      self.numPrevisao = somaPrevisaoDias
    },
    setDataEstimada (dataProcesso, diasPrevisao) {
      var self = this
      var data = new Date(util.formatarAnoMesDia(dataProcesso, 'DD/MM/YYYY'))

      var listaDatas = []
      // var feriados = 0

      // lista de dias em sequência, a partir da data do processo
      for (let i = 0; i < diasPrevisao; i++) {
        var datai = new Date(data)
        datai.setDate(data.getDate() + i)
        listaDatas.push(datai)

        // Verifica se é sábado ou domingo
        if (datai.getDay() === 6 || datai.getDay() === 0) {
          diasPrevisao = diasPrevisao + 1
        }
      }

      // // Adicionar Feriados nacionais e municipais
      // utilHttp.httpGet(api.PARAMETROS_SISTEMA, resposta => {
      //   if (resposta.body !== undefined && resposta.body !== '') {
      //     // Obtem a cidade e estado dos parametros do sistema
      //     self.parametrosSistema = resposta.body

      //     // CIDADE
      //     var nomMunicipio = self.parametrosSistema.municipio.nomMunicipio
      //     var municipio = nomMunicipio.replace(' ', '_')

      //     // ESTADO
      //     var estado = self.parametrosSistema.uf.sglUf
      //     // URL DA API
      //     let urlCalendario =
      //       'https://api.calendario.com.br/?json=true&ano=2019&estado=' +
      //       estado +
      //       '&cidade=' +
      //       municipio +
      //       '&token=ZGFuaWxvQGdvdmVybmEuY29tLmJyJmhhc2g9MTQ5NDMzNjEw'

      //     // BUSCAR O CALENDÁRIO DE FERIADOS NA API
      //     utilHttp.httpGet(urlCalendario, resposta => {
      //       var calendario = resposta.body
      //       calendario.forEach(c => {
      //         let data = null
      //         data = listaDatas.filter(
      //           d => new Date(d).toLocaleDateString() === c.date
      //         )

      //         if (data.length > 0) {
      //           if (c.type_code === 1 || c.type_code === 3) {
      //             var dataFeriado = new Date(dataFeriado)
      //             if (dataFeriado.getDay() === 5 || dataFeriado.getDay() === 6) {
      //               feriados = feriados + 1
      //             }
      //           }
      //         }
      //       })

      //       // Recupera a última data do vetor
      //       data = new Date(listaDatas[listaDatas.length - 1])

      //       // Adiciona os feriados
      //       for (let f = 1; f <= feriados; f++) {
      //         var dataf = new Date(data)
      //         dataf.setDate(data.getDate() + f)
      //         listaDatas.push(dataf)
      //       }

      //       // ESTIMATIVA DE CONCLUSÃO, Última data da lista
      //       self.dataEstimativaConclusao = new Date(
      //         listaDatas[listaDatas.length - 1]
      //       )
      //     })
      //   }
      // })
      // listaDatas

      // self.dataEstimativaConclusao = new Date(
      //   listaDatas[listaDatas.length - 1]
      // )
      self.dataEstimativaConclusao = util.formatarData(listaDatas[listaDatas.length - 1], 'dd/mm/yyyy')
    },
    limparSubassunto () {
      var self = this
      if (self.$refs['refSubAssunto']) self.$refs['refSubAssunto'].limpar()
      if (self.$refs['refTimeLine']) self.$refs['refTimeLine'].limpar()
      if (self.$refs['refJustificativa']) self.$refs['refJustificativa'].limpar()
      self.paginaStatus.aberturaProcesso.justificativa = {}
      self.paginaStatus.aberturaProcesso.roteiro.numRota = ''
      self.dadosRoteiroArray = []
      self.dadosDocumentoNecessarioArray = []
      self.paginaStatus.aberturaProcesso.txtObservacao = ''
      // self.paginaStatus.aberturaProcesso.justificativa.desJustificativa = ''
    },
    limparTipoProcesso () {
      var self = this
      if (self.$refs['refTipoProcesso']) self.$refs['refTipoProcesso'].limpar()
      if (self.$refs['refTimeLine']) self.$refs['refTimeLine'].limpar()
      if (self.$refs['refJustificativa']) self.$refs['refJustificativa'].limpar()
      if (self.$refs['refAssunto']) self.$refs['refAssunto'].limpar()
      if (self.$refs['refSubAssunto']) self.$refs['refSubAssunto'].limpar()
      self.paginaStatus.aberturaProcesso.justificativa = {}
      // self.codTipoProcesso = ''
      self.paginaStatus.aberturaProcesso.roteiro.numRota = ''
      self.dadosRoteiroArray = []
      self.dadosDocumentoNecessarioArray = []
      self.paginaStatus.aberturaProcesso.txtObservacao = ''
      self.paginaStatus.aberturaProcesso.tipoProcesso.txtCapaCor = ''
    },
    limparDadosRequerente () {
      var self = this
      // self.paginaStatus.aberturaProcesso.txtEmail = self.paginaStatus.aberturaProcesso.txtEmail === self.paginaStatus.aberturaProcesso.requerente.txtEmail ? '' : self.paginaStatus.aberturaProcesso.txtEmail
      self.paginaStatus.aberturaProcesso.requerente = {}
      if ((self.paginaStatus.aberturaProcesso.requerente.codRequerente === '' || self.paginaStatus.aberturaProcesso.requerente.codRequerente === undefined) &&
        (self.paginaStatus.aberturaProcesso.representante.codRequerente === '' || self.paginaStatus.aberturaProcesso.representante.codRequerente === undefined)) {
        self.txtEmailRequerente = ''
        self.txtEmailRepresentante = ''
      }
      self.paginaStatus.aberturaProcesso.txtEmail = self.txtEmailRepresentante
    },
    limparDadosRepresentante () {
      var self = this
      // self.paginaStatus.aberturaProcesso.txtEmail = self.paginaStatus.aberturaProcesso.txtEmail === self.paginaStatus.aberturaProcesso.representante.txtEmail ? '' : self.paginaStatus.aberturaProcesso.txtEmail
      self.paginaStatus.aberturaProcesso.representante = {}
      if ((self.paginaStatus.aberturaProcesso.requerente.codRequerente === '' || self.paginaStatus.aberturaProcesso.requerente.codRequerente === undefined) &&
        (self.paginaStatus.aberturaProcesso.representante.codRequerente === '' || self.paginaStatus.aberturaProcesso.representante.codRequerente === undefined)) {
        self.txtEmailRequerente = ''
        self.txtEmailRepresentante = ''
      }
      self.paginaStatus.aberturaProcesso.txtEmail = self.txtEmailRequerente
    },
    mascarasToString () {
      // if (this.paginaStatus.aberturaProcesso.horProcesso !== undefined) {

      //   this.paginaStatus.aberturaProcesso.horProcesso = util.mascaraHora(
      //     this.paginaStatus.aberturaProcesso.horProcesso.toString()
      //   )
      // }
      if (
        this.paginaStatus.aberturaProcesso.vlrProcesso !== undefined &&
        this.paginaStatus.aberturaProcesso.vlrProcesso !== null &&
        this.paginaStatus.aberturaProcesso.vlrProcesso !== ''
      ) {
        this.paginaStatus.aberturaProcesso.vlrProcesso = util.mascaraMoney(this.paginaStatus.aberturaProcesso.vlrProcesso)
      }

      if (this.paginaStatus.aberturaProcesso.requerente.numTelefoneMovel !== undefined &&
        this.paginaStatus.aberturaProcesso.requerente.numTelefoneMovel !== null &
        this.paginaStatus.aberturaProcesso.requerente.numTelefoneMovel !== ''
      ) {
        this.paginaStatus.aberturaProcesso.requerente.numTelefoneMovel = util.mascaraTelefone(
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneMovel.toString()
        )
      }
      if (this.paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial !== undefined &&
        this.paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial !== null &&
        this.paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial !== ''
      ) {
        this.paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial = util.mascaraTelefone(
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneResidencial.toString()
        )
      }
      if (this.paginaStatus.aberturaProcesso.requerente.numTelefoneComercial !== undefined &&
        this.paginaStatus.aberturaProcesso.requerente.numTelefoneComercial !== null &&
        this.paginaStatus.aberturaProcesso.requerente.numTelefoneComercial !== ''
      ) {
        this.paginaStatus.aberturaProcesso.requerente.numTelefoneComercial = util.mascaraTelefone(
          this.paginaStatus.aberturaProcesso.requerente.numTelefoneComercial.toString()
        )
      }
      if (this.paginaStatus.aberturaProcesso.representante.numTelefoneMovel !== undefined &&
        this.paginaStatus.aberturaProcesso.representante.numTelefoneMovel !== null &&
        this.paginaStatus.aberturaProcesso.representante.numTelefoneMovel !== ''
      ) {
        this.paginaStatus.aberturaProcesso.representante.numTelefoneMovel = util.mascaraTelefone(
          this.paginaStatus.aberturaProcesso.representante.numTelefoneMovel.toString()
        )
      }
      if (this.paginaStatus.aberturaProcesso.representante.numTelefoneResidencial !== undefined &&
        this.paginaStatus.aberturaProcesso.representante.numTelefoneResidencial !== null &&
        this.paginaStatus.aberturaProcesso.representante.numTelefoneResidencial !== ''
      ) {
        this.paginaStatus.aberturaProcesso.representante.numTelefoneResidencial = util.mascaraTelefone(
          this.paginaStatus.aberturaProcesso.representante.numTelefoneResidencial.toString()
        )
      }
      if (this.paginaStatus.aberturaProcesso.representante.numTelefoneComercial !== undefined &&
        this.paginaStatus.aberturaProcesso.representante.numTelefoneComercial !== null &&
        this.paginaStatus.aberturaProcesso.representante.numTelefoneComercial !== ''
      ) {
        this.paginaStatus.aberturaProcesso.representante.numTelefoneComercial = util.mascaraTelefone(
          this.paginaStatus.aberturaProcesso.representante.numTelefoneComercial.toString()
        )
      }
    },
    desabilitarCampos () {
      this.paginaStatus.desabilitarEdicao = true
      this.desabilitarSubAssunto = true
      this.desabilitarRota = true
      this.desabilitarAssunto = true
      if (this.paginaStatus.operacao.descricao === 'Visualizar') {
        this.desabilitarTipoProcesso = true
        this.visualizarSalvar = false
        this.desabilitarObs = true
        this.desabilitarFormaSolicitacao = true
        this.desabilitarTelefoneRequerente = true
        this.desabilitarTelefoneRepresentante = true
        this.desabilitarNumProcessoExterno = true
        this.desabilitarNumProcessoAnterior = true
        this.desabilitarAnoProcessoAnterior = true
        this.desabilitarComprovante = true
        this.desabilitarVlrProcesso = true
        this.desabilitarNotaFiscal = true
        this.desabilitarDataHoraProcesso = true
        this.desabilitarDocumentos = true
      } else {
        this.desabilitarTipoProcesso = false
        this.visualizarSalvar = true
        this.desabilitarObs = false
        this.desabilitarFormaSolicitacao = false
        this.desabilitarTelefoneRequerente = false
        this.desabilitarNumProcessoExterno = false
        this.desabilitarNumProcessoAnterior = false
        this.desabilitarAnoProcessoAnterior = false
        this.desabilitarComprovante = false
        this.desabilitarVlrProcesso = false
        this.desabilitarNotaFiscal = false
        this.desabilitarDataHoraProcesso = false
        this.desabilitarDocumentos = false
        if (this.paginaStatus.aberturaProcesso.representante !== null && this.paginaStatus.aberturaProcesso.representante !== '') {
          this.desabilitarTelefoneRepresentante = false
        } else {
          this.desabilitarTelefoneRepresentante = true
        }
      }
    },
    colocarDataProcesso () {
      var self = this

      let dp = new Date(self.paginaStatus.aberturaProcesso.datProcesso)
      let dia = String(dp.getDate()).padStart(2, '0')
      let mes = String(dp.getMonth() + 1).padStart(2, '0')
      let ano = String(dp.getFullYear())

      // var dHoraProcesso = ano + '-' + mes + '-' + dia + 'T' + self.paginaStatus.aberturaProcesso.horProcesso
      var dHoraProcesso = dia + '/' + mes + '/' + ano

      self.dataHoraProcesso = dHoraProcesso // new Date(dHoraProcesso)
      self.horaProcesso = String(self.paginaStatus.aberturaProcesso.horProcesso).substring(0, 5)
    },
    carregarGridDocumentos () {
      var self = this
      iniciar()
      async function iniciar () {
        let protocoloSolicitacaoMovimentacaoLista = await buscarDocumentos()
        let protocoloSolicitacaoMovimentacaoLista2 = await buscarDocumentosAnexados()
        if (protocoloSolicitacaoMovimentacaoLista.length > 0 || protocoloSolicitacaoMovimentacaoLista2.length > 0) {
          protocoloSolicitacaoMovimentacaoLista2.forEach(item => {
            if (self.paginaStatus.documentoAnexoProcessoSalvarList.filter(x => x.nomDocumento === item.nomDocumento).length === 0) {
              let documentoSelecionado = item
              if (item.nomDocumento) {
                documentoSelecionado.documento = {
                  nomDocumento: item.nomDocumento,
                  arquivo: null
                }
              } else {
                documentoSelecionado.documento = {
                  nomDocumento: item.documento.nomDocumento,
                  arquivo: null
                }
              }
              documentoSelecionado.tamanhoArquivo = item.tamanhoArquivo
              documentoSelecionado.indDisponibilidade = 'INT'
              self.paginaStatus.documentoAnexoProcessoSalvarList.push(documentoSelecionado)
            }
          })
          protocoloSolicitacaoMovimentacaoLista.forEach(item => {
            if (self.paginaStatus.documentoAnexoProcessoSalvarList.filter(x => x.documento.nomDocumento === item.servidorArquivo.nomeArquivo).length === 0) {
              let documentoSelecionado = item
              documentoSelecionado.documento = {
                nomDocumento: item.servidorArquivo.nomeArquivo,
                arquivo: null
              }
              documentoSelecionado.tamanhoArquivo = item.servidorArquivo.tamanho
              documentoSelecionado.indDisponibilidade = 'INT'
              self.paginaStatus.documentoAnexoProcessoSalvarList.push(documentoSelecionado)
            }
          })
          setTimeout(() => {
            if (self.$refs['refGridDocumentos']) {
              self.$refs['refGridDocumentos'].inicializar(util.clonarObjeto(self.paginaStatus.documentoAnexoProcessoSalvarList))
            }
          }, 250)
        } else {
          setTimeout(() => {
            if (self.$refs['refGridDocumentos']) {
              self.$refs['refGridDocumentos'].inicializar(util.clonarObjeto(self.paginaStatus.documentoAnexoProcessoSalvarList))
            }
          }, 250)
        }
      }
      async function buscarDocumentos () {
        return new Promise(resolve => {
          if (self.paginaStatus.aberturaProcesso.idProtocoloSolicitacao) {
            var filtro = '?id='.concat(self.paginaStatus.aberturaProcesso.idProtocoloSolicitacao)
            utilHttp.httpGet(api.PROTOCOLO_SOLICITACAO_MOVIMENTACAO_DOCUMENTOS.concat(filtro), resposta => {
              return resolve(resposta.body)
            })
          } else {
            return resolve([])
          }
        })
      }
      async function buscarDocumentosAnexados () {
        return new Promise(resolve => {
          if (self.paginaStatus.aberturaProcesso.codProcesso) {
            var filtro = '/'.concat(self.paginaStatus.aberturaProcesso.codProcesso)
            utilHttp.httpGet(api.BUSCAR_DOCUMENTO_ANEXO_PROCESSO_PELO_COD_PROCESSO.concat(filtro), resposta => {
              return resolve(resposta.body)
            })
          } else {
            return resolve([])
          }
        })
      }
    }
  },
  watch: {
    desEndereco: {
      handler (valor) {
        var self = this
        if (valor) {
          self.paginaStatus.aberturaProcesso.desEndereco = valor
        } else {
          self.paginaStatus.aberturaProcesso.desEndereco = ''
        }
      }
    },
    areaLote: {
      handler (valor) {
        var self = this
        if (valor) {
          self.paginaStatus.aberturaProcesso.areaLote = valor
        } else {
          self.paginaStatus.aberturaProcesso.areaLote = ''
        }
      }
    },
    tipoImovel: {
      handler (valor) {
        var self = this
        if (valor) {
          self.paginaStatus.aberturaProcesso.tipoImovel = valor
        } else {
          self.paginaStatus.aberturaProcesso.tipoImovel = ''
        }
      }
    },
    clonarProcesso: {
      handler (valor) {
        if (valor) {
          if (valor === 'N') {
            this.qdeProcesso = ''
            this.exibirQtdeClone = false
          } else {
            this.exibirQtdeClone = true
          }
        }
      }
    },
    qdeProcesso: {
      handler (valor) {
        if (valor) {
          this.paginaStatus.aberturaProcesso.qdeProcesso = valor
        } else {
          this.paginaStatus.aberturaProcesso.qdeProcesso = 1
        }
      }
    },
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)

        if (this.$refs['refNumProcesso']) {
          if (
            this.paginaStatus.aberturaProcesso.numProcesso !== '' &&
            this.paginaStatus.aberturaProcesso.numProcesso !== undefined
          ) {
            // this.paginaStatus.aberturaProcesso.datProcesso = ''
          }
        }

        if (this.$refs['refAnoProcesso']) {
          if (
            this.paginaStatus.aberturaProcesso.numProcesso !== '' &&
            this.paginaStatus.aberturaProcesso.numProcesso !== undefined
          ) {
            // this.paginaStatus.aberturaProcesso.horProcesso = '00:00'
          }
        }
        // Forma de solicitação
        if (this.$refs['refFormaSolicitacao']) {
          if (this.paginaStatus.operacao.descricao === 'Novo') {
            this.paginaStatus.aberturaProcesso.formaSolicitacao.termo = this.$refs['refFormaSolicitacao'].termo
          } // else {
          // this.paginaStatus.aberturaProcesso.formaSolicitacao = this.$refs['refFormaSolicitacao'].objetoSelecionado
          // }
        }
        // Tipo de processo
        if (this.$refs['refTipoProcesso']) {
          if (this.paginaStatus.operacao.descricao === 'Novo') {
            this.paginaStatus.aberturaProcesso.tipoProcesso.termo = this.$refs['refTipoProcesso'].termo
          } // else {
          // this.paginaStatus.aberturaProcesso.tipoProcesso = this.$refs['refTipoProcesso'].objetoSelecionado
          // }
          // this.paginaStatus.aberturaProcesso.tipoProcesso.txtCapaCor = this.$refs['refTipoProcesso'].objetoSelecionado
        }
        // Assunto
        if (this.$refs['refAssunto']) {
          if (this.paginaStatus.operacao.descricao === 'Novo') {
            this.paginaStatus.aberturaProcesso.subassunto.assunto.termo = this.$refs['refAssunto'].termo
          } // else {
          // this.paginaStatus.aberturaProcesso.subassunto.assunto = this.$refs['refAssunto'].objetoSelecionado
          // }
        }
        // Subassunto
        if (this.$refs['refSubAssunto']) {
          if (this.paginaStatus.operacao.descricao === 'Novo') {
            this.paginaStatus.aberturaProcesso.subassunto.termo = this.$refs['refSubAssunto'].termo
          } // else {
          // this.paginaStatus.aberturaProcesso.subassunto = this.$refs['refSubAssunto'].objetoSelecionado
          // }
        }
        // Requerente
        if (this.$refs['refRequerente']) {
          if (this.paginaStatus.operacao.descricao === 'Novo') {
            this.paginaStatus.aberturaProcesso.requerente.termo = this.$refs['refRequerente'].termo
          }
        }
        // Representante
        if (this.$refs['refRepresentante']) {
          if (this.paginaStatus.operacao.descricao === 'Novo') {
            if (this.paginaStatus.aberturaProcesso.representante !== null && this.paginaStatus.aberturaProcesso.representante !== undefined && this.paginaStatus.aberturaProcesso.representante !== '') {
              this.paginaStatus.aberturaProcesso.representante.termo = this.$refs['refRepresentante'].termo
            }
          }
        }
        // Justificativa
        if (this.$refs['refJustificativa']) {
          if (this.paginaStatus.operacao.descricao === 'Novo') {
            this.paginaStatus.aberturaProcesso.justificativa.termo = this.$refs['refJustificativa'].termo
          } // else {
          // this.paginaStatus.aberturaProcesso.justificativa = this.$refs['refJustificativa'].objetoSelecionado
          // }
        }
        // Responsável
        if (this.$refs['refResponsavel']) {
          if (this.paginaStatus.operacao.descricao === 'Novo') {
            this.paginaStatus.aberturaProcesso.responsavel.termo = this.$refs['refResponsavel'].termo
          } // else {
          // this.paginaStatus.aberturaProcesso.responsavel = this.$refs['refResponsavel'].objetoSelecionado
          // }
        }
      },
      deep: true
    },
    indLiberadoProtocolo: {
      handler (valor) {
        if (valor) {
          this.paginaStatus.aberturaProcesso.indLiberadoProtocolo = valor
        }
      }
    },
    indTipoEndereco: {
      handler (valor) {
        if (valor) {
          this.paginaStatus.aberturaProcesso.indTipoEndereco = valor
        }
      }
    },
    dataHoraProcesso: {
      handler (valor) {
        this.somaTempoTramitacao()
      }
    },
    codTipoProcesso: {
      handler (valor) {
        var self = this
        if (self.codTipoProcesso !== undefined && self.codTipoProcesso !== '') {
          self.paginaStatus.aberturaProcesso.tipoProcesso.codTipoProcesso = self.codTipoProcesso
          // É necessário carregar o termo do Tipo Processo aqui pois o v-model dele está fora do paginaStatus
          if (self.$refs['refTipoProcesso']) {
            if (util.validarCampo(self.$refs['refTipoProcesso'].termo)) {
              self.paginaStatus.aberturaProcesso.tipoProcesso.termo = self.$refs['refTipoProcesso'].termo
            }
            if (self.paginaStatus.operacao.descricao === 'Visualizar') {
              self.desabilitarAssunto = true
            } else {
              self.desabilitarAssunto = false // self.paginaStatus.operacao.descricao !== 'Novo' ? (self.desabilitarAssunto = true) : (self.desabilitarAssunto = false)
            }
          }
          // Precisa entrar nessa função de novo caso o Tipo de Processo seja apagado e depois escrito novamente, sem
          // apagar o Assunto e Subassunto
          if (self.paginaStatus.operacao.descricao === 'Novo' && self.codSubassunto && self.codAssunto) {
            self.buscarDocumentoNecessario()
          }
          // self.buscarRotaPeloProcessoSubassunto()
        } else {
          self.limparTipoProcesso()
          self.desabilitarRota = true

          self.desabilitarJustificativa = true
        }
      }
    },
    codAssunto: {
      handler (valor) {
        var self = this
        if (self.assuntoInicio) {
          self.$refs['refSubAssunto'].limpar()
        }

        if (self.codAssunto !== undefined && this.codAssunto !== '') {
          self.paginaStatus.aberturaProcesso.subassunto.assunto.codAssunto = self.codAssunto

          // É necessário carregar o termo do Assunto aqui pois o v-model dele está fora do paginaStatus
          if (this.$refs['refAssunto']) {
            if (util.validarCampo(this.$refs['refAssunto'].termo)) {
              self.paginaStatus.aberturaProcesso.subassunto.assunto.termo = this.$refs['refAssunto'].termo
              self.paginaStatus.aberturaProcesso.subassunto.assunto.desAssunto = this.$refs['refAssunto'].termo
            }
          }
          if (self.paginaStatus.operacao.descricao === 'Visualizar') {
            self.desabilitarSubAssunto = true
            self.desabilitarJustificativa = true
          } else {
            self.desabilitarSubAssunto = false // self.paginaStatus.operacao.descricao !== 'Novo' ? (self.desabilitarSubAssunto = true) : (self.desabilitarSubAssunto = false)
            self.desabilitarJustificativa = false
          }
          self.assuntoInicio = true
          // self.buscarRotaPeloProcessoSubassunto()
        } else {
          self.paginaStatus.aberturaProcesso.subassunto.assunto.codAssunto = ''
          self.paginaStatus.aberturaProcesso.subassunto = { assunto: {} }
          self.$refs['refSubAssunto'].limpar()
          self.desabilitarSubAssunto = true
          self.desabilitarJustificativa = true
          self.dadosDocumentoNecessarioArray = []
        }
      }
    },
    codSubassunto: {
      handler (valor) {
        if (this.subassuntoInicio) {
          if (this.$refs['refTimeLine']) this.$refs['refTimeLine'].limpar()
          if (this.$refs['refJustificativa']) this.$refs['refJustificativa'].limpar()
          this.paginaStatus.aberturaProcesso.justificativa = {}
          this.paginaStatus.aberturaProcesso.roteiro.numRota = ''
          this.dadosRoteiroArray = []
          this.dadosDocumentoNecessarioArray = []
          this.paginaStatus.aberturaProcesso.txtObservacao = ''
        }
        if (this.codSubassunto !== undefined && this.codSubassunto !== '') {
          this.paginaStatus.aberturaProcesso.subassunto.codSubassunto = this.codSubassunto

          // É necessário carregar o termo do Subassunto aqui pois o v-model dele está fora do paginaStatus
          if (this.$refs['refSubAssunto']) {
            if (this.$refs['refSubAssunto'].termo) {
              this.paginaStatus.aberturaProcesso.subassunto.termo = this.$refs['refSubAssunto'].termo
              this.paginaStatus.aberturaProcesso.subassunto.desSubassunto = this.$refs['refSubAssunto'].termo
            }
          }
          if (this.paginaStatus.operacao.descricao === 'Visualizar') {
            this.desabilitarRota = true
            this.desabilitarJustificativa = true
          } else {
            this.desabilitarRota = false // this.paginaStatus.operacao.descricao !== 'Novo' ? (this.desabilitarRota = true) : (this.desabilitarRota = false)
            this.desabilitarJustificativa = false
          }
          // Condição para buscar as rotas
          // this.buscarDocumentoNecessario()
          this.buscarRotaPeloProcessoSubassunto()
          this.subassuntoInicio = true
        } else {
          this.limparSubassunto()
          this.desabilitarRota = true
          this.desabilitarJustificativa = true
        }
        // this.paginaStatus.aberturaProcesso.responsavel.termo = ''
        // this.paginaStatus.aberturaProcesso.responsavel.codResponsavel = ''
        this.alterouSubAssunto = true
      }
    },
    abaSelecionada (valor) {
      if (valor === 'dadosProcesso') {
        if (this.paginaStatus.operacao.descricao === 'Novo') {
          // Carregando o termo de Forma de solicitação
          if (this.paginaStatus.aberturaProcesso.formaSolicitacao.termo) {
            setTimeout(() => {
              this.$refs['refFormaSolicitacao'].carregar(
                this.paginaStatus.aberturaProcesso.formaSolicitacao
                  .codFormaSolicitacao,
                this.paginaStatus.aberturaProcesso.formaSolicitacao.termo
              )
            }, 100)
          }
          // Carregando o termo de Tipo de processo
          if (this.paginaStatus.aberturaProcesso.tipoProcesso.termo) {
            setTimeout(() => {
              this.$refs['refTipoProcesso'].carregar(
                this.paginaStatus.aberturaProcesso.tipoProcesso.codTipoProcesso,
                this.paginaStatus.aberturaProcesso.tipoProcesso.termo
              )
            }, 100)
          }
          // Carregando o termo de Assunto
          if (this.paginaStatus.aberturaProcesso.subassunto.assunto.termo) {
            setTimeout(() => {
              this.$refs['refAssunto'].carregar(
                this.paginaStatus.aberturaProcesso.subassunto.assunto
                  .codAssunto,
                this.paginaStatus.aberturaProcesso.subassunto.assunto.termo
              )
            }, 100)
          }
          // Carregando o termo de Subassunto
          if (this.paginaStatus.aberturaProcesso.subassunto.termo) {
            setTimeout(() => {
              this.$refs['refSubAssunto'].carregar(
                this.paginaStatus.aberturaProcesso.subassunto.codSubassunto,
                this.paginaStatus.aberturaProcesso.subassunto.termo
              )
            }, 100)
          }
          if (this.paginaStatus.aberturaProcesso.justificativa.termo) {
            setTimeout(() => {
              this.$refs['refJustificativa'].carregar(
                this.paginaStatus.aberturaProcesso.justificativa
                  .codJustificativa,
                this.paginaStatus.aberturaProcesso.justificativa.termo
              )
            }, 100)
          }
        } else {
          // Carregando o termo de Forma de solicitação
          if (this.paginaStatus.aberturaProcesso.formaSolicitacao) {
            this.paginaStatus.aberturaProcesso.formaSolicitacao.termo = this.paginaStatus.aberturaProcesso.formaSolicitacao.desFormaSolicitacao
            setTimeout(() => {
              this.$refs['refFormaSolicitacao'].setTermo(this.paginaStatus.aberturaProcesso.formaSolicitacao.desFormaSolicitacao)
              this.$refs['refFormaSolicitacao'].carregar(
                this.paginaStatus.aberturaProcesso.formaSolicitacao
                  .codFormaSolicitacao,
                this.paginaStatus.aberturaProcesso.formaSolicitacao
                  .desFormaSolicitacao
              )
            }, 100)
          }
          // Carregando o termo de Tipo de processo
          if (this.paginaStatus.aberturaProcesso.tipoProcesso.codTipoProcesso) {
            this.paginaStatus.aberturaProcesso.tipoProcesso.termo = this.paginaStatus.aberturaProcesso.tipoProcesso.desTipoProcesso
            setTimeout(() => {
              this.$refs['refTipoProcesso'].setTermo(this.paginaStatus.aberturaProcesso.tipoProcesso.desTipoProcesso)
              this.$refs['refTipoProcesso'].carregar(
                this.paginaStatus.aberturaProcesso.tipoProcesso.codTipoProcesso,
                this.paginaStatus.aberturaProcesso.tipoProcesso.desTipoProcesso
              )
            }, 100)
          }
          // Carregando o termo de Assunto
          if (
            this.paginaStatus.aberturaProcesso.subassunto.assunto.codAssunto
          ) {
            this.paginaStatus.aberturaProcesso.subassunto.assunto.termo = this.paginaStatus.aberturaProcesso.subassunto.assunto.desAssunto
            setTimeout(() => {
              this.$refs['refAssunto'].setTermo(this.paginaStatus.aberturaProcesso.subassunto.assunto.desAssunto)
              this.$refs['refAssunto'].carregar(
                this.paginaStatus.aberturaProcesso.subassunto.assunto
                  .codAssunto,
                this.paginaStatus.aberturaProcesso.subassunto.assunto.desAssunto
              )
            }, 100)
          }
          // Carregando o termo de Subassunto
          if (this.paginaStatus.aberturaProcesso.subassunto.codSubassunto) {
            this.paginaStatus.aberturaProcesso.subassunto.termo = this.paginaStatus.aberturaProcesso.subassunto.desSubassunto
            setTimeout(() => {
              this.$refs['refSubAssunto'].setTermo(this.paginaStatus.aberturaProcesso.subassunto.desSubassunto)
              this.$refs['refSubAssunto'].carregar(
                this.paginaStatus.aberturaProcesso.subassunto.codSubassunto,
                this.paginaStatus.aberturaProcesso.subassunto.desSubassunto
              )
            }, 100)
          }
          // Carregando o termo de Justificativa
          if (this.paginaStatus.aberturaProcesso.justificativa.codJustificativa) {
            setTimeout(() => {
              this.$refs['refJustificativa'].carregar(
                this.paginaStatus.aberturaProcesso.justificativa
                  .codJustificativa,
                this.paginaStatus.aberturaProcesso.justificativa
                  .desJustificativa
              )
            }, 100)
          }
        }
      }
      if (valor === 'dadosRequerente') {
        if (this.paginaStatus.operacao.descricao === 'Novo') {
          // Carregando o termo de Requerente
          if (this.paginaStatus.aberturaProcesso.requerente.termo) {
            setTimeout(() => {
              this.$refs['refRequerente'].carregar(
                this.paginaStatus.aberturaProcesso.requerente.codRequerente,
                this.paginaStatus.aberturaProcesso.requerente.termo
              )
            }, 100)
          }
          // Carregando o termo de Representante
          if (this.paginaStatus.aberturaProcesso.representante.termo) {
            setTimeout(() => {
              this.$refs['refRepresentante'].carregar(
                this.paginaStatus.aberturaProcesso.representante.codRepresentante,
                this.paginaStatus.aberturaProcesso.representante.termo
              )
            }, 100)
          }
          // Email
          setTimeout(() => {
            this.$refs['refEmail'].validar()
          }, 100)
        } else {
          // Carregando o termo de Requerente
          if (this.paginaStatus.aberturaProcesso.requerente) {
            setTimeout(() => {
              this.$refs['refRequerente'].carregar(
                this.paginaStatus.aberturaProcesso.requerente.codRequerente,
                this.paginaStatus.aberturaProcesso.requerente.nomRequerente
              )
            }, 100)
          }
          // Carregando o termo de Representante
          if (this.paginaStatus.aberturaProcesso.representante) {
            setTimeout(() => {
              this.$refs['refRepresentante'].carregar(
                this.paginaStatus.aberturaProcesso.representante.codRequerente,
                this.paginaStatus.aberturaProcesso.representante.nomRequerente
              )
            }, 100)
          }
        }
      }
      if (valor === 'dadosComplemetares') {
        if (this.paginaStatus.operacao.descricao === 'Novo') {
          // Carregando o termo de Justificativa
          if (this.paginaStatus.aberturaProcesso.responsavel.codResponsavel) {
            setTimeout(() => {
              this.$refs['refResponsavel'].carregar(
                this.paginaStatus.aberturaProcesso.responsavel.codResponsavel,
                this.paginaStatus.aberturaProcesso.responsavel.usuario.nomUsuario
              )
            }, 100)
          }
          // // Carregando o termo de Responsável
          // if (!this.alterouSubAssunto) {
          //   if (this.paginaStatus.aberturaProcesso.responsavel.termo) {
          //     setTimeout(() => {
          //       this.$refs['refResponsavel'].carregar(
          //         this.paginaStatus.aberturaProcesso.responsavel.codResponsavel,
          //         this.paginaStatus.aberturaProcesso.responsavel.termo
          //       )
          //     }, 100)
          //   }
          // } else {
          //   setTimeout(() => {
          //     this.$refs['refResponsavel'].limpar()
          //   }, 100)
          // }
          this.alterouSubAssunto = false
        } else {
          // Carregando o termo de Responsável
          if (this.paginaStatus.aberturaProcesso.responsavel.codResponsavel) {
            setTimeout(() => {
              this.$refs['refResponsavel'].carregar(
                this.paginaStatus.aberturaProcesso.responsavel.codResponsavel,
                this.paginaStatus.aberturaProcesso.responsavel.usuario
                  .nomUsuario
              )
            }, 100)
          }
        }
      }
      if (valor === 'documentos') {
        if (this.paginaStatus.operacao.descricao === 'Novo') {
          this.carregarArquivosAnexadosNaSolicitacao()
        } else {
          this.carregarGridDocumentos()
        }
      }
    }
  },
  mounted () {
    if (this.$route.params.paginaStatus) {
      this.paginaStatus = this.$route.params.paginaStatus
      this.paginaStatus.caminhoMigalha.push({
        icone: this.paginaStatus.operacao.icone,
        descricao: this.paginaStatus.operacao.descricao,
        rotaNome: 'aberturaProcesso'
      })
    } else if (util.recuperarDoStorage(this.chaveLocalStorage)) {
      this.paginaStatus = util.recuperarDoStorage(this.chaveLocalStorage)
    }

    this.paginaStatus.aberturaProcesso.requerente.nomRequerente = this.paginaStatus.aberturaProcesso.requerente.nomeDataNascimentoDocumento
    if (this.paginaStatus.aberturaProcesso.representante.nomeDataNascimentoDocumento) {
      this.paginaStatus.aberturaProcesso.representante.nomRequerente = this.paginaStatus.aberturaProcesso.representante.nomeDataNascimentoDocumento
    } else {
      this.paginaStatus.aberturaProcesso.representante = ''
    }
    if (this.paginaStatus.aberturaProcesso.requerente) {
      this.txtEmailRequerente = this.paginaStatus.aberturaProcesso.requerente.txtEmail
    }
    if (this.paginaStatus.aberturaProcesso.representante) {
      this.txtEmailRepresentante = this.paginaStatus.aberturaProcesso.representante.txtEmail
    }

    this.clonarProcesso = 'N'
    this.abaSelecionada = 'dadosProcesso'
    this.imprimir = false
    this.buscarParametrosSistema()
    if (this.paginaStatus.operacao.descricao === 'Editar' || this.paginaStatus.operacao.descricao === 'Visualizar') {
      this.imprimir = true
    }
    if (this.paginaStatus.operacao.descricao !== 'Novo') {
      setTimeout(() => {
        this.buscarDadosRoteiro()
      }, 100)
      this.buscarDocumentacaoApresentada()
      this.mascarasToString()
      this.exibirClone = false
      this.areaLote = this.paginaStatus.aberturaProcesso.areaLote
      this.tipoImovel = this.paginaStatus.aberturaProcesso.tipoImovel
      this.desEndereco = this.paginaStatus.aberturaProcesso.desEndereco
      this.indLiberadoProtocolo = this.paginaStatus.aberturaProcesso.indLiberadoProtocolo
      this.indTipoEndereco = this.paginaStatus.aberturaProcesso.indTipoEndereco
      this.desabilitarCampos()

      this.colocarDataProcesso()
      this.codBarra = this.paginaStatus.aberturaProcesso.numProcesso.toString().concat(this.paginaStatus.aberturaProcesso.anoProcesso)
    } else {
      this.operacao = 'Novo'
      this.paginaStatus.aberturaProcesso.datProcesso = new Date()
      this.paginaStatus.aberturaProcesso.anoProcesso = this.paginaStatus.aberturaProcesso.datProcesso.getFullYear()

      this.indLiberadoProtocolo = 'S'
      this.indTipoEndereco = 'R'
      this.exibirClone = true

      this.setDataHoraAtual()
    }
  },
  components: {
    GBreadcrumb,
    GDatepicker,
    GAutocomplete,
    GSelect,
    GInput,
    GTimeLine,
    GDateInput,
    GGridview,
    GDatatable
    // requerente
  }
}
</script>
